var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoriesCategories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 479.1 539.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M140.5,435c-.63,7.38-6,13.8-14.09,16.88a30.52,30.52,0,0,1-10.94,2c-13.81,0-25-8.43-25-18.84,0-4.79,2.37-9.17,6.3-12.49l.8-.65c.28-.22.57-.43.87-.64.31.19.63.37,1,.55a33.81,33.81,0,0,0,31.38.45,28.8,28.8,0,0,0,2.69-1.59c.3-.19.6-.39.89-.61.3.19.59.4.87.61a9.6,9.6,0,0,1,.79.64,11.92,11.92,0,0,1,1,1,11.62,11.62,0,0,1,1.32,1.71c.13.2.26.41.38.63s.24.43.35.66.21.45.31.69.18.43.26.66a5.05,5.05,0,0,1,.18.55,5.26,5.26,0,0,1,.18.6l.06.22c0,.14.07.28.1.43s.09.42.13.64.1.54.13.82a.78.78,0,0,1,0,.16q.06.38.09.78A24.5,24.5,0,0,1,140.5,435Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.52,399.7a8.52,8.52,0,0,0-.08-.87,20.24,20.24,0,0,0-.41-2.35c-.07-.31-.15-.63-.25-.94a1.36,1.36,0,0,0-.07-.25c-.1-.37-.22-.73-.35-1.09s-.27-.76-.43-1.14-.29-.68-.45-1a1.42,1.42,0,0,0-.08-.18c-.13-.27-.26-.53-.4-.79l-.18-.35c-.14-.26-.29-.51-.45-.77l-.2-.33-.35-.55c-.17-.27-.35-.53-.54-.79l-.08-.1a8.72,8.72,0,0,0-.53-.71l-.4-.51c-.15-.19-.31-.38-.48-.56l-.25-.29c-.18-.21-.38-.42-.58-.63s-.4-.42-.61-.62-.53-.51-.8-.76l0,0-.74-.65-.81-.66a10,10,0,0,1-.81.65,29.85,29.85,0,0,1-7,4,33.4,33.4,0,0,1-12.66,2.44,32.14,32.14,0,0,1-19.69-6.47c-.28-.21-.55-.42-.81-.65-.28.21-.55.44-.81.66l-.74.65a23.43,23.43,0,0,0-8.07,17.34c0,8.06,4.43,15.24,11.33,19.9l.87.56c.3.19.61.38.92.55a34.78,34.78,0,0,0,32.27.93,28.15,28.15,0,0,0,3.61-2.11c.29-.19.57-.39.85-.6s.55-.41.82-.64c5.89-4.61,9.58-11.24,9.58-18.59A16.56,16.56,0,0,0,145.52,399.7Zm-10.34,19.72c-.28.22-.56.43-.85.63s-.59.42-.89.61a28.8,28.8,0,0,1-2.69,1.59,33.81,33.81,0,0,1-31.38-.45c-.32-.18-.64-.36-1-.55s-.6-.37-.89-.57c-6.8-4.48-11.18-11.44-11.18-19.25a22.43,22.43,0,0,1,7.86-16.69,34.08,34.08,0,0,0,21.26,7.16,35.39,35.39,0,0,0,12.83-2.36,31.9,31.9,0,0,0,8.44-4.8,22.43,22.43,0,0,1,7.86,16.69C144.6,408.54,141,415,135.18,419.42Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.75,419.35c0,1,0,1.94,0,2.9a33.81,33.81,0,0,1-31.38-.45c-.32-.18-.64-.36-1-.55s-.6-.37-.89-.57c-6.8-4.48-11.18-11.44-11.18-19.25a22.43,22.43,0,0,1,7.86-16.69,34.08,34.08,0,0,0,21.26,7.16,35.39,35.39,0,0,0,12.83-2.36q.48,5.77,1.22,11.89c.67,5.56,1.06,10.81,1.18,15.78,0,.36,0,.71,0,1.07S130.74,419,130.75,419.35Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.19,361.25c-.06-.3-.12-.61-.19-.9,0,0,0-.05,0-.08s0,0,0,0,0-.05,0-.07c0-.23-.12-.44-.18-.66a4.13,4.13,0,0,0-.15-.5c-.09-.31-.19-.61-.3-.91s-.12-.34-.19-.51l-.24-.61q-.16-.4-.36-.81t-.3-.63c0-.1-.1-.2-.16-.3s-.18-.36-.28-.54l-.06-.11c-.22-.38-.45-.77-.69-1.14s-.31-.49-.48-.73l-.3-.43-.31-.42c-.21-.28-.43-.56-.65-.83l-.35-.42-.34-.39c-.21-.25-.44-.5-.67-.74a9.63,9.63,0,0,0-.72-.71l-.83.6a27,27,0,0,1-9.66,4.08,32.44,32.44,0,0,1-21.94-3.4A33.53,33.53,0,0,1,99,345.26c-.26-.23-.52-.47-.77-.72-.3.17-.6.35-.89.54s-.57.37-.85.56c-6.81,4.67-11.17,11.81-11.17,19.8a23.45,23.45,0,0,0,8.07,17.35l.74.65.8.65a33.17,33.17,0,0,0,20.51,6.81,34.46,34.46,0,0,0,12.74-2.39,30.89,30.89,0,0,0,7.78-4.43c.27-.2.54-.42.8-.64l.74-.65a23.45,23.45,0,0,0,8.07-17.35A21.49,21.49,0,0,0,145.19,361.25Zm-8.45,20.88c-.25.23-.5.45-.76.65a10,10,0,0,1-.81.65,29.85,29.85,0,0,1-7,4,33.4,33.4,0,0,1-12.66,2.44,32.14,32.14,0,0,1-19.69-6.47c-.28-.21-.55-.42-.81-.65a9.19,9.19,0,0,1-.75-.65,22.39,22.39,0,0,1-7.87-16.69c0-7.71,4.27-14.6,10.92-19.07a35.94,35.94,0,0,0,7.57,5.43,35.07,35.07,0,0,0,16.64,4.27,32.74,32.74,0,0,0,6.13-.58,28.78,28.78,0,0,0,11.19-4.69,22,22,0,0,1,5.8,14.64A22.43,22.43,0,0,1,136.74,382.13Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.13,387.46a33.4,33.4,0,0,1-12.66,2.44,32.14,32.14,0,0,1-19.69-6.47c-.28-.21-.55-.42-.81-.65a9.19,9.19,0,0,1-.75-.65,22.39,22.39,0,0,1-7.87-16.69c0-7.71,4.27-14.6,10.92-19.07a35.94,35.94,0,0,0,7.57,5.43,35.07,35.07,0,0,0,16.64,4.27,32.74,32.74,0,0,0,6.13-.58c-.35,6.7-.4,13.87-.08,21.54,0,.36,0,.72,0,1.08s0,.72.05,1.09Q127.82,383.24,128.13,387.46Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.37,325.94c0-.32-.1-.65-.16-1s-.12-.63-.19-1-.16-.7-.25-1.06c-.16-.59-.33-1.18-.52-1.76-.11-.34-.23-.67-.36-1-.22-.63-.48-1.24-.76-1.86-.13-.31-.28-.61-.43-.92s-.3-.61-.46-.91-.32-.6-.49-.89a.08.08,0,0,0,0,0l-.51-.85c-.18-.29-.36-.58-.56-.86-.3.16-.6.3-.9.43a31.69,31.69,0,0,1-8.62,2.52,33.5,33.5,0,0,1-4.62.32c-11.58,0-21.67-6.07-26.73-14.95-.18-.29-.34-.58-.49-.87l-.9.45-.87.47a24.73,24.73,0,0,0-9.65,9.8c-5.61,10.4-2.89,23.31,5.79,32.33.22.25.46.48.7.72s.5.49.76.72a34.14,34.14,0,0,0,7.18,5.12,33.44,33.44,0,0,0,22.35,3.56,27.54,27.54,0,0,0,10.45-4.41c.28-.19.56-.39.83-.6s.48-.37.71-.57l.06,0c.24-.19.47-.39.7-.6l.28-.25c.22-.19.43-.39.64-.61l.21-.2c.2-.19.39-.39.58-.6s.21-.23.31-.35.32-.35.47-.53.3-.36.44-.54.45-.57.66-.87l.43-.6c.22-.32.43-.65.63-1s.46-.76.67-1.16a24.36,24.36,0,0,0,2-5q.3-1.1.51-2.22c.07-.4.14-.8.19-1.21s.08-.69.11-1,.05-.6.06-.89,0-.53,0-.79,0-.39,0-.58A26.94,26.94,0,0,0,148.37,325.94Zm-3.52,15.15a23.39,23.39,0,0,1-5.83,7.05l-.8.62-.83.6a27,27,0,0,1-9.66,4.08,32.44,32.44,0,0,1-21.94-3.4A33.53,33.53,0,0,1,99,345.26c-.26-.23-.52-.47-.77-.72s-.49-.47-.72-.71c-8.49-8.74-11.19-21.27-5.78-31.33a23.73,23.73,0,0,1,9.24-9.4c5.41,9.52,16.16,16,28.52,16a32.6,32.6,0,0,0,4-.24A33.16,33.16,0,0,0,143.81,316a29.17,29.17,0,0,1,2.14,4.52A24.73,24.73,0,0,1,144.85,341.09Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.5,318.89a143.38,143.38,0,0,0-4.66,22.64c-.05.34-.09.68-.13,1s-.09.7-.12,1.05c-.38,3.16-.66,6.43-.86,9.83a32.44,32.44,0,0,1-21.94-3.4A33.53,33.53,0,0,1,99,345.26c-.26-.23-.52-.47-.77-.72s-.49-.47-.72-.71c-8.49-8.74-11.19-21.27-5.78-31.33a23.73,23.73,0,0,1,9.24-9.4c5.41,9.52,16.16,16,28.52,16A32.6,32.6,0,0,0,133.5,318.89Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.59,299.5a29.54,29.54,0,0,1-13.15-5.39,32.56,32.56,0,0,1-12.59-19.27,33.3,33.3,0,0,1-.25-13.69c.07-.33.14-.66.22-1l-1-.05c-.34,0-.68,0-1,0h-.27c-17.25,0-31.24,13-31.24,29A27.09,27.09,0,0,0,101,300.85c.14.31.29.61.45.91s.31.58.47.86c5.23,9.22,15.65,15.51,27.65,15.51a31.87,31.87,0,0,0,4.29-.28,32.53,32.53,0,0,0,9.5-2.7l.91-.43c.3-.15.6-.3.89-.46a29.94,29.94,0,0,0,12.63-12.73c.17-.31.32-.63.47-.95s.29-.64.42-1C158.28,299.59,157.94,299.55,157.59,299.5Zm-13,13.9c-.3.17-.6.32-.9.46s-.6.3-.9.43a31.69,31.69,0,0,1-8.62,2.52,33.5,33.5,0,0,1-4.62.32c-11.58,0-21.67-6.07-26.73-14.95-.18-.29-.34-.58-.49-.87s-.31-.6-.44-.9a26,26,0,0,1-2.58-11.3c0-15.46,13.57-28,30.24-28h.07a35.09,35.09,0,0,0,.31,14.2,34.49,34.49,0,0,0,13.5,20.54,31.53,31.53,0,0,0,13.3,5.56A29.13,29.13,0,0,1,144.56,313.4Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.4,295.82a90.17,90.17,0,0,0-5.26,10.31l-.42,1c-.14.32-.27.65-.41,1-1.13,2.75-2.2,5.66-3.17,8.74a33.5,33.5,0,0,1-4.62.32c-11.58,0-21.67-6.07-26.73-14.95-.18-.29-.34-.58-.49-.87s-.31-.6-.44-.9a26,26,0,0,1-2.58-11.3c0-15.46,13.57-28,30.24-28h.07a35.09,35.09,0,0,0,.31,14.2A34.49,34.49,0,0,0,143.4,295.82Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.64,261.54c0-.14-.06-.28-.1-.41-4.13-17.31-20.6-28.3-37-24.6-11.34,2.57-19.7,11.53-22.5,22.59q-.13.5-.24,1l-.21,1a34.08,34.08,0,0,0,.26,13.95,33.52,33.52,0,0,0,13,19.92,30.45,30.45,0,0,0,13.25,5.46l1.05.14,1,.11a28.74,28.74,0,0,0,8.68-.63C184.45,296.33,194.61,279.08,190.64,261.54Zm-22.92,37.55a27.52,27.52,0,0,1-8.05.62c-.35,0-.69,0-1-.09s-.69-.07-1-.12a29.54,29.54,0,0,1-13.15-5.39,32.56,32.56,0,0,1-12.59-19.27,33.3,33.3,0,0,1-.25-13.69c.07-.33.14-.66.22-1s.15-.66.24-1a31.44,31.44,0,0,1,3.34-8.05,28.56,28.56,0,0,1,18.39-13.62,27.89,27.89,0,0,1,6.21-.7,29,29,0,0,1,16.24,5.07,31.73,31.73,0,0,1,8.56,8.57,33.2,33.2,0,0,1,4.76,10.89c0,.14.07.28.1.42C193.5,278.73,183.66,295.48,167.72,299.09Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.28,484.18c-3,3.51-7.48,5.29-13.31,5.22-3.8,0-7-.13-9.84-.26a77.35,77.35,0,0,1-13.77-1.56c5.49-2.47,18.78-9.35,24.52-20.13,3.09-1.8,11.11-5.73,14.93-4.42a3,3,0,0,1,.76.38,2.66,2.66,0,0,1,1,1.21C122.72,465.84,124.16,477.32,118.28,484.18Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.54,464.62c.18,1.22,1.62,12.7-4.26,19.56-3,3.51-7.48,5.29-13.31,5.22-3.8,0-7-.13-9.84-.26a60.23,60.23,0,0,0,26.44-25.73A2.66,2.66,0,0,1,122.54,464.62Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f8d906"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.94,300.06a28.74,28.74,0,0,1-8.68.63l-1-.11c-.15.32-.3.64-.47.95a29.94,29.94,0,0,1-12.63,12.73c-.29.16-.59.31-.89.46l.51.85a.08.08,0,0,1,0,0c.17.29.33.59.49.89s.32.61.46.91.3.61.43.92c.28.62.54,1.23.76,1.86.13.34.25.67.36,1,.19.58.36,1.17.52,1.76.09.36.18.71.25,1.06s.13.63.19,1,.12.65.16,1a26.94,26.94,0,0,1,.29,3.9v.31a2.44,2.44,0,0,1,0,.27c0,.26,0,.52,0,.79s0,.59-.06.89-.07.69-.11,1-.12.81-.19,1.21a22.2,22.2,0,0,1-.51,2.22,24.36,24.36,0,0,1-2,5c-.21.4-.44.78-.67,1.16s-.41.66-.63,1l-.43.6q-.31.45-.66.87c-.14.18-.28.36-.44.54s-.3.36-.47.53-.2.24-.31.35-.38.41-.58.6l-.21.2c-.21.22-.42.42-.64.61l-.28.25c-.23.21-.46.41-.7.6l-.06,0c-.23.2-.47.39-.71.57.23.24.46.49.67.74l.34.39.35.42c.22.27.44.55.65.83l.31.42.3.43c.17.24.33.48.48.73s.47.76.69,1.14l.06.11c.1.18.19.36.28.54s.11.2.16.3.21.42.3.63.25.54.36.81l.24.61c.07.17.13.34.19.51s.21.6.3.91a4.13,4.13,0,0,1,.15.5c.06.22.13.43.18.66,0,0,0,.05,0,.07s0,0,0,0,0,.05,0,.08c.07.29.13.6.19.9a21.49,21.49,0,0,1,.41,4.19,23.45,23.45,0,0,1-8.07,17.35l-.74.65.74.65,0,0c.27.25.54.5.8.76s.41.41.61.62.4.42.58.63l.25.29c.17.18.33.37.48.56l.4.51a8.72,8.72,0,0,1,.53.71l.08.1c.19.26.37.52.54.79l.35.55.2.33c.16.26.31.51.45.77l.18.35c.14.26.27.52.4.79a1.42,1.42,0,0,1,.08.18c.16.33.31.67.45,1s.3.75.43,1.14.25.72.35,1.09a1.36,1.36,0,0,1,.07.25c.1.31.18.63.25.94a20.24,20.24,0,0,1,.41,2.35,8.52,8.52,0,0,1,.08.87,16.56,16.56,0,0,1,.08,1.73c0,7.35-3.69,14-9.58,18.59-.27.23-.54.44-.82.64a9.6,9.6,0,0,1,.79.64,11.92,11.92,0,0,1,1,1,11.62,11.62,0,0,1,1.32,1.71c.13.2.26.41.38.63s.24.43.35.66.21.45.31.69.18.43.26.66a5.05,5.05,0,0,1,.18.55,5.26,5.26,0,0,1,.18.6l.06.22c0,.14.07.28.1.43s.09.42.13.64.1.54.13.82a.78.78,0,0,1,0,.16q.06.38.09.78a24.5,24.5,0,0,1,0,4.19c-.63,7.38-6,13.8-14.09,16.88l.39-1.25a98.62,98.62,0,0,0,3.91-26.17l0-1.12c0-.37,0-.74,0-1.12a28.8,28.8,0,0,0,2.69-1.59c.3-.19.6-.39.89-.61s.57-.41.85-.63c5.79-4.47,9.42-10.88,9.42-18a22.43,22.43,0,0,0-7.86-16.69,31.9,31.9,0,0,1-8.44,4.8l-.09-1c0-.35-.05-.7-.08-1.05a29.85,29.85,0,0,0,7-4,10,10,0,0,0,.81-.65c.26-.2.51-.42.76-.65a22.43,22.43,0,0,0,7.86-16.69,22,22,0,0,0-5.8-14.64,28.78,28.78,0,0,1-11.19,4.69c0-.34,0-.67,0-1s0-.69.07-1a27,27,0,0,0,9.66-4.08l.83-.6.8-.62a23.39,23.39,0,0,0,5.83-7.05,24.73,24.73,0,0,0,1.1-20.57,29.17,29.17,0,0,0-2.14-4.52,33.16,33.16,0,0,1-10.31,2.89c.1-.35.2-.7.31-1l.33-1a31.69,31.69,0,0,0,8.62-2.52c.3-.13.6-.27.9-.43s.6-.29.9-.46a29.13,29.13,0,0,0,12.14-12,31.53,31.53,0,0,1-13.3-5.56l.51-.84c.18-.29.36-.58.53-.87a29.54,29.54,0,0,0,13.15,5.39c.35.05.69.09,1,.12s.69.07,1,.09a27.52,27.52,0,0,0,8.05-.62c15.94-3.61,25.78-20.36,21.94-37.33,0-.14-.06-.28-.1-.42l1-.21c0,.13.07.27.1.41C194.61,279.08,184.45,296.33,167.94,300.06Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f8d906"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.76,421.62c-.31-.33-.63-.65-1-.94s-.51-.45-.78-.66-.55-.41-.84-.6c-.28.22-.56.43-.85.63s-.59.42-.89.61c.32.2.62.4.91.6s.56.42.82.64a12.61,12.61,0,0,1,1.12,1.07c2.61,2.84,3.66,6.76,3.21,12-.6,6.94-5.55,12.73-12.7,15.71a29.19,29.19,0,0,1-11.33,2.21c-13.24,0-24-8-24-17.84,0-4.58,2.34-8.77,6.19-11.94l.83-.65c.29-.21.59-.43.9-.64-.32-.18-.64-.36-1-.55s-.6-.37-.89-.57c-.29.2-.57.42-.85.65a9.59,9.59,0,0,0-.78.65c-4,3.48-6.45,8-6.45,13,0,10.94,11.68,19.84,26,19.84,13.87,0,25.06-8.49,26-19.75C142,429.39,140.73,424.85,137.76,421.62Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.6,401.43c0,7.11-3.63,13.52-9.42,18-.28.22-.56.43-.85.63s-.59.42-.89.61a28.8,28.8,0,0,1-2.69,1.59c0-1,0-1.92,0-2.9,0-.36,0-.71,0-1.07s0-.71,0-1.07c-.12-5-.51-10.22-1.18-15.78q-.75-6.12-1.22-11.89a31.9,31.9,0,0,0,8.44-4.8A22.43,22.43,0,0,1,144.6,401.43Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f8d906"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.27,383.43l-.74-.64c-.25-.23-.52-.45-.79-.66-.25.23-.5.45-.76.65a10,10,0,0,1-.81.65c.28.21.55.43.82.65l.75.66a22.43,22.43,0,0,1,7.86,16.69c0,7.11-3.63,13.52-9.42,18-.28.22-.56.43-.85.63s-.59.42-.89.61a28.8,28.8,0,0,1-2.69,1.59,33.81,33.81,0,0,1-31.38-.45c-.32-.18-.64-.36-1-.55s-.6-.37-.89-.57c-6.8-4.48-11.18-11.44-11.18-19.25a22.43,22.43,0,0,1,7.86-16.69c.24-.23.49-.44.75-.65s.54-.45.82-.66c-.28-.21-.55-.42-.81-.65a9.19,9.19,0,0,1-.75-.65c-.28.21-.54.43-.8.66l-.74.65a24.35,24.35,0,0,0-8.33,18c0,8.29,4.51,15.7,11.55,20.55.28.2.56.39.85.56s.59.38.89.55a34.66,34.66,0,0,0,17.83,4.8,35.08,35.08,0,0,0,15.24-3.4,31.09,31.09,0,0,0,4.46-2.59c.28-.19.55-.39.82-.6s.54-.4.81-.62c6-4.82,9.8-11.67,9.8-19.25A24.39,24.39,0,0,0,138.27,383.43Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.6,365.44a22.43,22.43,0,0,1-7.86,16.69c-.25.23-.5.45-.76.65a10,10,0,0,1-.81.65,29.85,29.85,0,0,1-7,4q-.31-4.23-.51-8.26c0-.37,0-.73-.05-1.09s0-.72,0-1.08c-.32-7.67-.27-14.84.08-21.54a28.78,28.78,0,0,0,11.19-4.69A22,22,0,0,1,144.6,365.44Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f8d906"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.39,349.59c-.22-.25-.45-.5-.68-.74s-.46-.47-.69-.71l-.8.62-.83.6a9.63,9.63,0,0,1,.72.71c.24.24.46.48.69.73a22,22,0,0,1,5.8,14.64,22.43,22.43,0,0,1-7.86,16.69c-.25.23-.5.45-.76.65a10,10,0,0,1-.81.65,29.85,29.85,0,0,1-7,4,33.4,33.4,0,0,1-12.66,2.44,32.14,32.14,0,0,1-19.69-6.47c-.28-.21-.55-.42-.81-.65a9.19,9.19,0,0,1-.75-.65,22.39,22.39,0,0,1-7.87-16.69c0-7.71,4.27-14.6,10.92-19.07.28-.2.57-.39.86-.57s.59-.37.9-.54c-.26-.23-.52-.47-.77-.72s-.49-.47-.72-.71c-.29.16-.58.34-.87.53s-.57.37-.84.57c-7,4.85-11.48,12.24-11.48,20.51a24.37,24.37,0,0,0,8.33,18l.74.65c.25.22.52.44.79.65a34.08,34.08,0,0,0,21.26,7.16,35.39,35.39,0,0,0,12.83-2.36,31.9,31.9,0,0,0,8.44-4.8c.27-.21.53-.43.79-.65s.5-.43.74-.66a24.35,24.35,0,0,0,8.33-18A23.86,23.86,0,0,0,140.39,349.59Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.85,341.09a23.39,23.39,0,0,1-5.83,7.05l-.8.62-.83.6a27,27,0,0,1-9.66,4.08c.2-3.4.48-6.67.86-9.83,0-.35.08-.7.12-1.05s.08-.69.13-1a143.38,143.38,0,0,1,4.66-22.64A33.16,33.16,0,0,0,143.81,316a29.17,29.17,0,0,1,2.14,4.52A24.73,24.73,0,0,1,144.85,341.09Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f8d906"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.82,319.83a29.85,29.85,0,0,0-2.22-4.72,8.1,8.1,0,0,0-.49-.85c-.17-.29-.35-.58-.55-.86-.3.17-.6.32-.9.46s-.6.3-.9.43c.19.28.37.57.55.86s.34.56.5.85a29.17,29.17,0,0,1,2.14,4.52,24.73,24.73,0,0,1-1.1,20.57,23.39,23.39,0,0,1-5.83,7.05l-.8.62-.83.6a27,27,0,0,1-9.66,4.08,32.44,32.44,0,0,1-21.94-3.4A33.53,33.53,0,0,1,99,345.26c-.26-.23-.52-.47-.77-.72s-.49-.47-.72-.71c-8.49-8.74-11.19-21.27-5.78-31.33a23.73,23.73,0,0,1,9.24-9.4l.87-.48.92-.44c-.18-.29-.34-.58-.49-.87s-.31-.6-.44-.9c-.31.13-.61.28-.91.44l-.87.48A25.51,25.51,0,0,0,87,323.73a31.16,31.16,0,0,0,8.87,21.2c.22.24.45.48.69.71l.75.73a35.94,35.94,0,0,0,7.57,5.43,35.07,35.07,0,0,0,16.64,4.27,32.74,32.74,0,0,0,6.13-.58,28.78,28.78,0,0,0,11.19-4.69c.28-.19.55-.39.81-.59s.53-.41.78-.62a25.26,25.26,0,0,0,6.22-7.55A26.66,26.66,0,0,0,147.82,319.83Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.7,301.38a29.13,29.13,0,0,1-12.14,12c-.3.17-.6.32-.9.46s-.6.3-.9.43a31.69,31.69,0,0,1-8.62,2.52c1-3.08,2-6,3.17-8.74.14-.32.27-.65.41-1l.42-1a90.17,90.17,0,0,1,5.26-10.31A31.53,31.53,0,0,0,156.7,301.38Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f8d906"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.63,299.62c-.35,0-.69-.07-1-.12-.13.32-.27.63-.43.94s-.3.63-.46.94a29.13,29.13,0,0,1-12.14,12c-.3.17-.6.32-.9.46s-.6.3-.9.43a31.69,31.69,0,0,1-8.62,2.52,33.5,33.5,0,0,1-4.62.32c-11.58,0-21.67-6.07-26.73-14.95-.18-.29-.34-.58-.49-.87s-.31-.6-.44-.9a26,26,0,0,1-2.58-11.3c0-15.46,13.57-28,30.24-28h.07q.51,0,1,0c.34,0,.67,0,1,0,.07-.33.14-.66.22-1s.15-.66.24-1c-.33,0-.67-.05-1-.06s-.69,0-1,0h-.5c-17.78,0-32.24,13.47-32.24,30a28.06,28.06,0,0,0,2.8,12.22q.21.45.45.9c.15.29.31.58.47.87,5.41,9.52,16.16,16,28.52,16a32.6,32.6,0,0,0,4-.24A33.16,33.16,0,0,0,143.81,316c.31-.13.62-.28.92-.43l.87-.46a31,31,0,0,0,13.2-13.46c.16-.32.31-.64.46-1s.28-.65.41-1C159.32,299.69,159,299.66,158.63,299.62Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.61,261.31a34.47,34.47,0,0,0-14.25-21.09,30.38,30.38,0,0,0-43.68,9.89,33.35,33.35,0,0,0-3.66,9c-.09.33-.16.66-.23,1s-.14.66-.2,1a35.09,35.09,0,0,0,.31,14.2,34.49,34.49,0,0,0,13.5,20.54,31.53,31.53,0,0,0,13.3,5.56c.34.06.69.11,1,.15s.71.09,1.06.12c.91.09,1.83.13,2.76.13a29.88,29.88,0,0,0,6.6-.74C185.18,297.19,195.7,279.37,191.61,261.31Zm-31.94,38.4c-.35,0-.69,0-1-.09s-.69-.07-1-.12a29.54,29.54,0,0,1-13.15-5.39,32.56,32.56,0,0,1-12.59-19.27,33.3,33.3,0,0,1-.25-13.69c.07-.33.14-.66.22-1s.15-.66.24-1a31.44,31.44,0,0,1,3.34-8.05,28.56,28.56,0,0,1,18.39-13.62,27.89,27.89,0,0,1,6.21-.7,29,29,0,0,1,16.24,5.07,31.73,31.73,0,0,1,8.56,8.57,33.2,33.2,0,0,1,4.76,10.89c0,.14.07.28.1.42,3.84,17-6,33.72-21.94,37.33A27.52,27.52,0,0,1,159.67,299.71Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.56,261.34A69.56,69.56,0,0,0,159,276.91l-.77.68-.79.72a77.18,77.18,0,0,0-13,15.8,32.56,32.56,0,0,1-12.59-19.27,33.3,33.3,0,0,1-.25-13.69c.07-.33.14-.66.22-1s.15-.66.24-1a31.44,31.44,0,0,1,3.34-8.05,28.56,28.56,0,0,1,18.39-13.62,27.89,27.89,0,0,1,6.21-.7,29,29,0,0,1,16.24,5.07,31.73,31.73,0,0,1,8.56,8.57A33.2,33.2,0,0,1,189.56,261.34Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.72,299.09a27.52,27.52,0,0,1-8.05.62c-.35,0-.69,0-1-.09s-.69-.07-1-.12a29.54,29.54,0,0,1-13.15-5.39,77.18,77.18,0,0,1,13-15.8l.79-.72.77-.68a69.56,69.56,0,0,1,30.59-15.57c0,.14.07.28.1.42C193.5,278.73,183.66,295.48,167.72,299.09Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f8d906"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.51,464.2l-.05-.2a4.73,4.73,0,0,0-3-2.85c-5.6-1.92-16.39,4.47-16.84,4.74l-.25.14-.13.26C98,478.37,80.9,485.67,78.51,486.64c-1.06-.28-4.82-1.47-5.23-4.13-.15-1,0-1.48.29-1.65a.49.49,0,0,1,.51,0,.76.76,0,0,1,.36.76,1,1,0,0,0,1,1,1,1,0,0,0,1-1A2.76,2.76,0,0,0,75,479.09a2.5,2.5,0,0,0-2.62.14c-.56.39-1.45,1.39-1.11,3.59.65,4.13,6,5.58,6.93,5.81,1.1.59,6.37,2.63,26.73,2.78h.23c6.34,0,11.25-2,14.62-5.92C126.59,477.58,124.6,464.75,124.51,464.2Zm-6.22,20c-3,3.51-7.48,5.29-13.31,5.22-14-.11-20.65-1.1-23.61-1.82,5.49-2.47,18.78-9.35,24.52-20.13,3.09-1.8,11.11-5.73,14.93-4.42a2.71,2.71,0,0,1,1.73,1.59C122.73,465.85,124.17,477.33,118.29,484.19Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.26,453.25s12.6-10.08,18-16.06c4.44-5,20.6-9.11,19.41,12.14S148,481.46,138.41,473s-11.4-11.83-13.1-12S123.26,453.25,123.26,453.25Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f06ba6",
      stroke: "#231f20",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.7,463s-15,20.75-22.8,9.51c0,0-15.58-12.78-10-29.53,5-14.94,12.58-11.78,19.23-6.47,7,5.58,10.66,11.69,13.52,14.3,1.82,1.66,1.3,4.78.93,7.21Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f06ba6",
      stroke: "#231f20",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,458.17c-.09,7.95-5.45,9.47-12.17,9.51s-12.11-.7-12.17-9.51c0-5.25-.94-9.51,12.17-9.51C120.58,448.66,126.11,451.08,126,458.17Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f06ba6",
      stroke: "#231f20",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.31,461.89a1,1,0,0,1-.34-.14,1,1,0,0,1-.31-1.37,5.48,5.48,0,0,0,.66-3.8,4.86,4.86,0,0,0-2.58-2.93c-4.07-2.26-12.65,2.87-15.35,4.67-.46.31-.41-.76-.72-1.22a1,1,0,0,1,.28-1.39c.44-.29,10.78-7.11,16.76-3.81a6.75,6.75,0,0,1,3.55,4.2,7.43,7.43,0,0,1-.91,5.35A1,1,0,0,1,144.31,461.89Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,463.69a.94.94,0,0,1-.32-.08c-.21-.09-5.27-2.26-6.27-6a5.79,5.79,0,0,1,1.29-5.15c5-6.52,18.47,3,19,3.38a1,1,0,0,1,.23,1.39c-.32.45-.07,1.55-.52,1.23-3.44-2.46-14-8.93-17.17-4.78a3.88,3.88,0,0,0-.94,3.41c.75,2.84,5.08,4.7,5.12,4.72a1,1,0,0,1-.46,1.92Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.43,495c-12.42,15.85-39.73,20.64-55.22,14.15a20,20,0,0,1-12.1-16.2c-.76-6.24,1.29-11.91,4.69-16.87,9.19-13.42,28.27-21.6,28.27-21.6C224.75,441.92,245,459,245,459,251.59,474.29,249.26,486.33,242.43,495Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#15ad9f",
      stroke: "#231f20",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.37,503.38c-13.81,4.6-28.83-.11-40.91-7.54-10.24-6.3-18.38-14.55-21.9-20.72-7.66-13.44,5.11-16.68,5.11-16.68s22.63-5.27,32.51-6.47,13.61,3.07,30.63,10.73a23.58,23.58,0,0,1,6.95,4.75C349.09,477.69,347.88,496.21,326.37,503.38Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#15ad9f",
      stroke: "#231f20",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.37,503.38c-13.81,4.6-28.83-.11-40.91-7.54,1.22-9.17,9.66-19.28,22.25-25.37,11.28-5.46,23-6.3,31.05-3C349.09,477.69,347.88,496.21,326.37,503.38Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#0f5e54",
      stroke: "#231f20",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.43,495c-12.42,15.85-39.73,20.64-55.22,14.15a20,20,0,0,1-12.1-16.2c-.76-6.24,1.29-11.91,4.69-16.87,9.4-4.25,23.66-4,37.91,1.52C228.39,481.79,237.05,488.13,242.43,495Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#0f5e54",
      stroke: "#231f20",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.67 402.75 146.67 433.51 167.41 441.09 175.3 429.49 173.79 401.35 146.67 402.75",
    style: {
      fill: "#fdc98b",
      stroke: "#231f20",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.84 405.46 206.66 447.37 225.71 447.37 233.42 441.11 234.92 434.99 233.42 395.75 209.84 405.46",
    style: {
      fill: "#fdc98b",
      stroke: "#231f20",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.51,443.12c-1.86-1.77-2-4.39-1.92-7.15,0-.89.31-1.58-.05-1.68-.93-.25-10.37-1.78-9.79,8.56s13.72,16.69,21,18c7.81,1.4,28.29-3.39,25-16.15,0,0-.87-8-6.06-5.61a4,4,0,0,0-1.61,2.48c-.59,2.73-5.24,8.3-14.68,7.15A20,20,0,0,1,216.51,443.12Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#ec262b",
      stroke: "#231f20",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.24,442.57s-15.4-.21-11.19,11.79,29.87,9.83,29.87,9.83,24.39-2.3,20.43-19c0,0-4-10.85-12.68-6v0a12,12,0,0,1-10.54,14,26.9,26.9,0,0,1-8.62-.24,9.33,9.33,0,0,1-7.29-10.24Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#ec262b",
      stroke: "#231f20",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.83 326.68 278.54 326.63 277.82 306.98 330.29 312.11 334 327.57 334.22 328.52 279.83 326.68",
    style: {
      fill: "#fcc98b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.82,321.23,391,325.54l7,.68,2.6,10.82.95,4,0,.16-53.42-1.82-.59,0-.66-18.09m-1.56-1.66.06,1.71.66,18.1,0,1.38,1.39.06.6,0,53.42,1.82,1.94.06-.43-1.89,0-.16-1-4-2.59-10.82-.25-1-1.07-.1-7-.68L347,319.73l-1.7-.16Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.07,339.34,396.19,341l5.3.18,0-.16c-2.42,0-4.6-.7-5.91-2.92a11.69,11.69,0,0,1-1-2.62,5,5,0,0,0-1.89-.65c-9-1.52-38.1,6.47-43.06,1.19C347.3,333.56,347.31,335.87,348.07,339.34Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#faae78"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M402.2,314.86a7.46,7.46,0,0,1-3.07,3.6,14.51,14.51,0,0,0-6,7.1,8,8,0,0,0,.47,6.88,3.36,3.36,0,0,1,.33,1.77l0,.32a10.46,10.46,0,0,0,1,5.91,8.78,8.78,0,0,0,.64,1,9.08,9.08,0,0,0,5.44,3.22,27.75,27.75,0,0,0,11.55-.14,20,20,0,0,1,6.86-.13c3,.49,6.09.86,9.14,1.27a6.67,6.67,0,0,0,4.28-.66c2.75-1.57,3.37-4.13,1.69-7.28.85,0,1.63,0,2.41-.07a5.45,5.45,0,0,0,5.17-6.4,5,5,0,0,0-2.37-3.33c2.36-1.69,3.3-3.84,2.18-6.57-1-2.45-3-3.38-5.63-3.32a4.62,4.62,0,0,0-.56-4.51,5.32,5.32,0,0,0-6.25-1.69c-3.44,1.27-6.78,2.81-10.2,4.13-2.88,1.09-5.8,2-8.71,3a4.74,4.74,0,0,1-.88.09l1.66-2.48c.72-1.07,1.57-2.09,2.17-3.21a7.21,7.21,0,0,0-.1-7.23c-1.82-3.2-5.58-3.46-7.94-.64a11.75,11.75,0,0,0-2.2,5.5A21.16,21.16,0,0,1,402.2,314.86Zm35,12.18c-2.86.43-5.73.82-8.6,1.21l-8.15,1.14c-.39-1.57-.8-3.05-1.11-4.54-.05-.2.3-.65.54-.72,2.24-.72,4.46-1.42,6.71-2,3.13-.86,6.26-1.72,9.43-2.42a3.78,3.78,0,0,1,4.75,3.11C441.13,325,439.77,326.67,437.23,327ZM424.58,336c-1.34,0-2.69-.08-4-.12,0-1.91,0-3.69,0-5.49l.53-.09,15.33-1.36a6.08,6.08,0,0,1,1.35.06,3.29,3.29,0,0,1,2.68,4.52,4.19,4.19,0,0,1-4.38,2.75C432.26,336.15,428.42,336.05,424.58,336Zm-22.47-18.1a12.41,12.41,0,0,0,2.72-6.71c.29-2,.8-3.86,2.4-5.21a3,3,0,0,1,4.39.3,5.82,5.82,0,0,1,.61,6.31c-.56,1.07-1.35,2-2,3.07a18.25,18.25,0,0,0-1.93,3.32c-.62,1.62-.09,2.23,1.53,1.75,3-.86,6-1.82,9-2.93,3.53-1.33,7-2.86,10.48-4.29a4.7,4.7,0,0,1,4.26.1,2.81,2.81,0,0,1,.52,4.75,6.12,6.12,0,0,1-2.19,1.18c-4.07,1.28-8.16,2.47-12.26,3.66a3.1,3.1,0,0,1-1.18-.14,41.7,41.7,0,0,1,1.32,15.22c.2-1.15,1-1.14,1.88-1.07,2.75.19,5.51.29,8.26.46a7.65,7.65,0,0,1,2.24.47,2.8,2.8,0,0,1,1.18,4.56,4.36,4.36,0,0,1-.78.77,3.55,3.55,0,0,1-.82.47,2.86,2.86,0,0,1-.41.15h0a2.28,2.28,0,0,1-.45.11l-.4.07a4.6,4.6,0,0,1-1.05,0,4.38,4.38,0,0,1-.51,0c-2.14-.28-4.3-.55-6.43-.89a29.86,29.86,0,0,0-11.23-.09,22,22,0,0,1-9.89,0l-.5-.13-.22-.06c-2.31-.68-4.2-2-4.81-4.51a11.82,11.82,0,0,1-.22-2.8c0-.72,0-1.45,0-2.17a2.24,2.24,0,0,0-.23-1.15,6.65,6.65,0,0,1-.46-7,14.49,14.49,0,0,1,5.34-5.91A10.22,10.22,0,0,0,402.11,317.85Z",
    transform: "translate(-68.22 -13.42)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M420.59,335.82c1.31.05,2.65.11,4,.13,3.84.1,7.68.2,11.51.27a4.19,4.19,0,0,0,4.38-2.75A3.28,3.28,0,0,0,437.8,329a5.64,5.64,0,0,0-1.36-.05l-15.32,1.35-.54.09C420.59,332.14,420.59,333.92,420.59,335.82Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fcc98b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.37,324.85c.31,1.49.72,3,1.11,4.54l8.15-1.13c2.87-.4,5.74-.8,8.6-1.22,2.55-.37,3.9-2,3.56-4.26a3.77,3.77,0,0,0-4.74-3.11c-3.17.7-6.3,1.57-9.43,2.42-2.25.63-4.48,1.32-6.71,2C419.67,324.2,419.33,324.64,419.37,324.85Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fcc98b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.83,311.14a12.41,12.41,0,0,1-2.72,6.71,10.22,10.22,0,0,1-1.89,1.64,14.62,14.62,0,0,0-5.23,5.67,2.56,2.56,0,0,0-.11.24,6.65,6.65,0,0,0,.46,7,2.24,2.24,0,0,1,.23,1.15c0,.72,0,1.45,0,2.17a11.82,11.82,0,0,0,.22,2.8c.61,2.5,2.5,3.83,4.81,4.51a5.42,5.42,0,0,0,.72.19,22,22,0,0,0,9.89,0,29.86,29.86,0,0,1,11.23.09c2.13.34,4.29.61,6.43.89a5,5,0,0,0,3.66-.77,4.36,4.36,0,0,0,.78-.77,2.8,2.8,0,0,0-1.18-4.56,7.65,7.65,0,0,0-2.24-.47c-2.75-.17-5.51-.27-8.26-.46-.91-.07-1.68-.08-1.88,1.07A41.7,41.7,0,0,0,418.42,323a3.1,3.1,0,0,0,1.18.14c4.1-1.19,8.19-2.38,12.26-3.66a6.12,6.12,0,0,0,2.19-1.18,2.81,2.81,0,0,0-.52-4.75,4.7,4.7,0,0,0-4.26-.1c-3.49,1.43-6.95,3-10.48,4.29-2.94,1.11-6,2.07-9,2.93-1.62.48-2.15-.13-1.53-1.75a18.25,18.25,0,0,1,1.93-3.32c.65-1,1.44-2,2-3.07a5.82,5.82,0,0,0-.61-6.31,3,3,0,0,0-4.39-.3C405.63,307.28,405.12,309.18,404.83,311.14Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fcc98b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.56,335.69a11.82,11.82,0,0,0,.22,2.8c.61,2.5,2.5,3.83,4.81,4.51l.22.06.5.13a22,22,0,0,0,9.89,0,29.86,29.86,0,0,1,11.23.09c2.13.34,4.29.61,6.43.89a4.38,4.38,0,0,0,.51,0,4.6,4.6,0,0,0,1.05,0l.4-.07a3.69,3.69,0,0,0,.45-.11h0a2.86,2.86,0,0,0,.41-.15,4.46,4.46,0,0,0,.82-.47c-3.14-1.66-11-5.31-18.76-5.05-6.06.21-9.91,1.06-12.93.56A8.18,8.18,0,0,1,395.56,335.69Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#faae78"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M408.71,325.16a10.19,10.19,0,0,1-4.78,7.06A8,8,0,0,0,408.71,325.16Z",
    transform: "translate(-68.22 -13.42)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M417,326.66l.8,6.72A14.6,14.6,0,0,0,417,326.66Z",
    transform: "translate(-68.22 -13.42)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.9,366.36a24.62,24.62,0,0,1-16.81-6.78c-6.6-6-10.38-15.07-10.38-24.82,0-16.51,10.66-30,24.8-31.46a23.76,23.76,0,0,1,2.39-.13c15,0,27.19,14.18,27.19,31.59S213.9,366.36,198.9,366.36Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#15ac9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.9,304.17c14.46,0,26.19,13.7,26.19,30.59s-11.73,30.59-26.19,30.59a23.77,23.77,0,0,1-16.14-6.51c-6.12-5.59-10-14.3-10-24.08,0-16,10.5-29.12,23.9-30.47a21.81,21.81,0,0,1,2.29-.12m0-2a23.27,23.27,0,0,0-2.5.14,26.85,26.85,0,0,0-18.33,10.49,35.52,35.52,0,0,0-7.36,22c0,10,3.9,19.35,10.7,25.56a25.62,25.62,0,0,0,17.49,7c15.55,0,28.19-14.61,28.19-32.59s-12.64-32.59-28.19-32.59Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.41,354.32c-15,0-27.19-14.18-27.19-31.59,0-13.76,7.56-25.83,18.81-30.06a23.52,23.52,0,0,1,8.38-1.54c15,0,27.19,14.18,27.19,31.6a34.07,34.07,0,0,1-8.1,22.49A25.2,25.2,0,0,1,327.41,354.32Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#15ac9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.41,292.13c14.46,0,26.19,13.7,26.19,30.59a33.17,33.17,0,0,1-7.86,21.84,24.29,24.29,0,0,1-18.33,8.75c-14.47,0-26.19-13.69-26.19-30.59,0-13.62,7.62-25.16,18.16-29.12a22.56,22.56,0,0,1,8-1.47m0-2a24.6,24.6,0,0,0-8.74,1.6c-11.63,4.38-19.45,16.83-19.45,31,0,18,12.65,32.59,28.19,32.59a26.19,26.19,0,0,0,19.84-9.43,35,35,0,0,0,8.35-23.16c0-18-12.64-32.59-28.19-32.59Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.6,322.72a33.17,33.17,0,0,1-7.86,21.84,61.07,61.07,0,0,1-.65-8.35c-.38-28.9-17.3-39.25-25.71-42.61a22.56,22.56,0,0,1,8-1.47C341.87,292.13,353.6,305.83,353.6,322.72Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#0aa58c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.11,354.08c.31,1.71.52,3.3.65,4.76-6.12-5.59-10-14.3-10-24.08,0-16,10.5-29.12,23.9-30.47C188.73,313.18,177.83,330.32,182.11,354.08Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#0aa58c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.27,434.24c-1.06,0-2.12,0-3.19-.06a194.46,194.46,0,0,1-27.78-2.94l-.09,0a237.79,237.79,0,0,1-67.91-23.31l-.91-.51.55-.89c.41-.64,40.37-64.63,54.39-93.19,2.79-5.68,4.37-9.6,4.72-11.65l.13-.81,66.1-1.74.3.51c.33.58,33.4,57.53,71.66,94.78l.8.78-.86.71C366.71,396.28,319.91,434.24,269.27,434.24Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#4fc9f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.71,300.13s33,57.21,71.83,95c0,0-46.4,38.11-97.27,38.11-1,0-2.1,0-3.16-.05a192.27,192.27,0,0,1-27.72-2.95h0A234.76,234.76,0,0,1,170.79,407s40.23-64.35,54.43-93.28c2.68-5.46,4.43-9.66,4.81-11.93l64.68-1.7m1.14-2-1.19,0L230,299.84l-1.65,0-.27,1.62c-.22,1.35-1.21,4.41-4.63,11.38-14,28.51-53.93,92.46-54.33,93.1L168,407.76l1.82,1A238.87,238.87,0,0,0,238,432.2l.18,0h0a193.44,193.44,0,0,0,27.83,2.95c1.06,0,2.15.05,3.22.05,26.69,0,52.06-10.48,68.65-19.28a196.16,196.16,0,0,0,29.89-19.28l1.73-1.42-1.6-1.56c-38.17-37.16-71.17-94-71.49-94.55l-.6-1Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.54,395.12s-48.34,39.7-100.43,38.06a192.27,192.27,0,0,1-27.72-2.95,187.06,187.06,0,0,0,67.33-14.58,30.47,30.47,0,0,0,13.37-45.41c-9.62-14-19.77-29.88-30.08-37.41-15.83-11.56-51.89-17.41-63.79-19.07,2.68-5.46,4.43-9.66,4.81-11.93l64.68-1.7S327.73,357.34,366.54,395.12Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#1ba6df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.81,149.41s-35.52,4.6-42.1-23,12.46-40.83,21.05-38.15c0,0-1.37-8.8,1.7-12.51s8.68-2.29,8.68-2.29,6.49-40.64,32.42-52.09c27.75-12.25,48.26-7.66,66.9,9.19,0,0,7.57-6,14.21,1.62,0,0,16.65-18.72,34.58-13.85,18.19,4.93,20.26,20.91,20.46,26.36,0,0,13.3-.68,15,9.19,0,0,31.15-20.93,48.85,23,16.85,41.8-16,53.28-22.13,53.28l-21.36,27.32-144,22.46Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f06ba8",
      stroke: "#231f20",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.18,124.15s-19.09,27.33-18.4,34.86,10.57,14,18.4,15.35S202.46,157.68,201.6,151,181.18,124.15,181.18,124.15Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#eb4d9b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.41,102.79s-37.05,20.53-39.23,37.37,11.42,19.59,11.42,19.59,16.09,8.5,21.32-6.57S261.41,102.79,261.41,102.79Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#eb4d9b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.19,120.17s-24.36-6.08-36.84,16.47,6.55,18.66,6.55,18.66Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#eb4d9b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.67,232.67c-.21-.54-22-55-45.67-83.28a82.77,82.77,0,0,0-8-8.45l-1.71-1.55,2.3-.19s.45,0,1.32,0c6,0,28,1.74,57,24.12l1.31,1c.83-6.56,3.83-29.83,6.45-44.11,2.2-12,3.11-12.26,3.92-12.5a1.46,1.46,0,0,1,.38,0c.7,0,2.82,0,25.22,20,5,4.45,17.45,15.8,21.29,19.83,2.67-4.74,12.69-22.41,20.66-35.26,9.2-14.84,10.47-14.9,11.31-14.94l.6,0,.31.51c.14.23,14,23.21,23.84,36.82l.19.26h0c5.11,7.05,7.14,8.82,7.87,9.26,3.56-3.43,26.24-25,36.64-25a7.29,7.29,0,0,1,1.26.11l1.18.22-.43,1.12s-.23.6-.64,1.72c-3.12,8.6-13.33,39.22-13.77,72.15v.77L170,233.49Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#e82529"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.43,98.27s13.93,23.09,23.89,36.89h0c4.22,5.85,7.71,10,9.13,10.08,0,0,25.6-25.11,36.38-25.11a6,6,0,0,1,1.07.09s-.23.6-.64,1.73c-2.75,7.58-13.39,39-13.83,72.48l-12.35,3.1L170.6,232.3s-21.82-54.82-45.84-83.56a85,85,0,0,0-8.11-8.55s.43,0,1.24,0c5.32,0,27.29,1.49,56.34,23.91.89.69,1.79,1.39,2.69,2.12,0,0,3.57-29,6.66-45.82,1.23-6.7,2.38-11.48,3.21-11.72h.11c3.7,0,46.2,39.18,46.7,40.53,0,0,12-21.38,21.32-36.43,5-8.13,9.32-14.41,10.51-14.47m1.1-2-1.2.06c-1.29.06-2.63.13-12.11,15.41-7.43,12-16.62,28.11-20,34.12-1.08-1.08-2.73-2.66-5.22-5-4.45-4.18-10-9.25-15.2-13.9C190.1,106.64,188,106.64,186.9,106.64a2.13,2.13,0,0,0-.67.1c-1.47.42-2.41,1.25-4.61,13.27-2.43,13.24-5.18,34.17-6.24,42.42-29.21-22.52-51.38-24.27-57.49-24.27-.87,0-1.35,0-1.4,0l-4.61.38,3.43,3.1a81.84,81.84,0,0,1,7.92,8.35c23.53,28.16,45.3,82.47,45.51,83l.65,1.63,1.7-.43,138.48-34.76,12.35-3.1,1.49-.37,0-1.54c.43-32.77,10.61-63.26,13.71-71.82.4-1.1.63-1.69.63-1.7l.86-2.24-2.36-.44a7.39,7.39,0,0,0-1.43-.13c-10.36,0-31.3,19.44-36.72,24.66-.94-.83-2.93-2.94-6.84-8.34l-.34-.47c-9.79-13.57-23.66-36.52-23.79-36.75l-.62-1Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.26,122c-2.75,7.58-13.39,39-13.83,72.48l-12.35,3.1a70.2,70.2,0,0,1-.25-12.73C310.79,150.74,324.43,131.77,335.26,122Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#d41e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.6,149.17c-15.77-14.55-39.43-24.72-50-28.8,1.23-6.7,2.38-11.48,3.21-11.72C189.69,107.8,233.09,147.8,233.6,149.17Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#d41e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.32,135.16c-24.4-25.35-34.4-22.42-34.4-22.42,5-8.13,9.32-14.41,10.51-14.47C265.43,98.27,279.36,121.36,289.32,135.16Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#d41e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.92,166.19c-20-12.19-41.66-15.48-52.16-17.45a85,85,0,0,0-8.11-8.55s24.08-2,57.58,23.88Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#d41e27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.38,164.21c3.14,5.15,18.62,30.82,24,46.9a2.16,2.16,0,0,0,4.05.12c1-2.55,1.44-6.27-.52-11.17-3.83-9.57-22.94-43.16-27.41-38.27A2,2,0,0,0,141.38,164.21Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f0582b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.45,138.44s-5.2,15-6.91,22.23c.59-7.12,1.63-22.33,4-26.1C186.92,129.34,186.45,138.44,186.45,138.44Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f0582b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.18,128.53s-6,7.65-11.11,14.59a.72.72,0,0,1-1.23-.73c3.75-7.72,8.44-16.82,11.26-19.15C258.51,118.79,254.18,128.53,254.18,128.53Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f0582b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.86,136.46s-6.36,3.53-11.8,6.89c-.55.34-1.44-.55-1-1,4.33-4.43,9.69-9.55,12.51-10.26C324,130.72,318.86,136.46,318.86,136.46Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f0582b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.22,355.89c0,8.18-5.17,15.26-12.7,18.68a24.68,24.68,0,0,1-10.19,2.17c-12.65,0-22.9-9.33-22.9-20.85,0-.33,0-.65,0-1,0-.14,0-.27,0-.4a6.2,6.2,0,0,1,.06-.62,1.36,1.36,0,0,1,0-.2l.06-.48c0-.11,0-.21.05-.32a.88.88,0,0,1,0-.16c0-.07,0-.14,0-.22.06-.32.13-.64.2-.95s.16-.66.25-1,.19-.64.3-.95l.91.41.42.19a29.16,29.16,0,0,0,20.15.94c.59-.17,1.18-.38,1.77-.6A29.43,29.43,0,0,0,503.46,340c.19-.26.38-.53.55-.8l.79.61c.26.21.51.44.76.67C509.09,343.77,511.22,348.74,511.22,355.89Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.86,314.29A27.73,27.73,0,0,0,493.53,299l-1-.45c-.33-.14-.67-.28-1-.4q0,.54,0,1.08a25.88,25.88,0,0,1-2.12,9.67,26.36,26.36,0,0,1-16.15,14.59,28.31,28.31,0,0,1-20.08-1c-.52-.23-1-.47-1.54-.73-.32-.15-.63-.31-.94-.49-.06.35-.11.7-.15,1.06s-.08.71-.11,1.07c-.07.76-.1,1.52-.1,2.28s0,1.62.11,2.43.18,1.63.33,2.44c.07.4.16.81.25,1.21.18.81.41,1.61.67,2.41q.19.6.42,1.2c.31.82.66,1.62,1,2.4.07.16.15.31.23.46l.06.12a2,2,0,0,0,.13.25c.26.48.53,1,.82,1.42.11.18.21.35.33.52s.24.37.36.55.34.5.53.74c.33.47.69.93,1.07,1.38a8.14,8.14,0,0,0,.54.63c.38.43.77.85,1.18,1.26l.08.08.05.05.29.27.35.33c.3.28.62.56.93.82s.53.44.79.64l.17.14h0c.33.26.66.5,1,.74s.58.39.87.59l.08.05.21.13.93.57,0,0c.33.19.67.38,1,.56l0,0,.9.46c.3.15.61.29.92.42a30.21,30.21,0,0,0,21.25,1.1c.58-.17,1.16-.37,1.73-.59a30.46,30.46,0,0,0,14.16-10.89c.2-.26.38-.53.56-.8l.57-.88h0A28,28,0,0,0,507.86,314.29Zm-3.29,24c-.18.3-.37.59-.56.88s-.36.54-.55.8a29.43,29.43,0,0,1-13.73,10.56c-.59.22-1.18.43-1.77.6a29.16,29.16,0,0,1-20.15-.94l-.42-.19-.91-.41c-.3-.15-.59-.3-.88-.47a26.44,26.44,0,0,1-14.19-25.27c.32.16.65.31,1,.45a30.53,30.53,0,0,0,12.12,2.52,29.88,29.88,0,0,0,9.88-1.67,29.32,29.32,0,0,0,6-2.88,28.09,28.09,0,0,0,13.11-22.24,26.58,26.58,0,0,1,12.43,35.74A27.66,27.66,0,0,1,504.57,338.33Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.93,335.81a27.66,27.66,0,0,1-1.36,2.52c-.18.3-.37.59-.56.88s-.36.54-.55.8a29.43,29.43,0,0,1-13.73,10.56c-.59.22-1.18.43-1.77.6-2-4.92-4.28-9.62-6.64-14.09l-.48-.9c-.16-.29-.32-.59-.49-.88q-2.84-5.25-6-10.11a29.32,29.32,0,0,0,6-2.88,28.09,28.09,0,0,0,13.11-22.24,26.58,26.58,0,0,1,12.43,35.74Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.52,297.43a28.91,28.91,0,0,0-17.62-25.21,29.41,29.41,0,0,0-11.9-2.43c-.33,0-.67,0-1,0s-.68,0-1,.06c0,.33.08.66.1,1a26,26,0,0,1-12,24,27.59,27.59,0,0,1-12.87,4.26c-.34,0-.67.05-1,.06,0,.33.05.67.09,1s.08.66.13,1c.08.52.17,1,.28,1.56s.23,1,.37,1.55c.08.3.17.61.27.92a23.2,23.2,0,0,0,.86,2.42c.09.23.19.46.29.69s.13.29.2.44.11.25.17.36.11.24.17.36.24.48.36.71c.25.47.51.94.79,1.4.13.23.27.45.42.68l.44.67c.3.44.62.88.94,1.3a.76.76,0,0,1,.08.11c.3.39.62.77.94,1.15l.48.55.61.66.47.48.68.66,0,0,.72.65.44.37.17.14.59.47.6.46c.44.33.9.65,1.37,1l0,0,.7.44.72.43c.31.19.62.36.94.53s.63.33,1,.49.84.4,1.27.59a29.25,29.25,0,0,0,21.06.91,27.36,27.36,0,0,0,16.48-15.07,26.7,26.7,0,0,0,2.2-9.65c0-.36,0-.73,0-1.09S492.53,297.8,492.52,297.43Zm-3.11,11.44a26.36,26.36,0,0,1-16.15,14.59,28.31,28.31,0,0,1-20.08-1c-.52-.23-1-.47-1.54-.73-.32-.15-.63-.31-.94-.49s-.62-.34-.92-.53a28,28,0,0,1-13.33-19.64A29.66,29.66,0,0,0,450,296.65c.19-.12.38-.24.57-.38a28,28,0,0,0,12.5-25.49h.08a28.53,28.53,0,0,1,11.33,2.36,28,28,0,0,1,17,23.9c0,.36,0,.72,0,1.08s0,.72,0,1.08A25.88,25.88,0,0,1,489.41,308.87Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.53,298.12q0,.54,0,1.08a25.88,25.88,0,0,1-2.12,9.67,26.36,26.36,0,0,1-16.15,14.59,153.87,153.87,0,0,0-13.48-17.63c-.22-.26-.45-.51-.67-.76s-.44-.49-.67-.73q-3.81-4.23-7.85-8.07a28,28,0,0,0,12.5-25.49h.08a28.53,28.53,0,0,1,11.33,2.36,28,28,0,0,1,17,23.9C491.52,297.4,491.53,297.76,491.53,298.12Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.09,270.8q0-.49-.09-1c0-.33-.08-.66-.13-1a29.46,29.46,0,0,0-39.8-22.66h0c-.32.11-.63.24-.94.38l-.95.44h0c.07.34.12.68.16,1a33.89,33.89,0,0,1,.27,4.3,33,33,0,0,1-5.4,18.24,29.3,29.3,0,0,1-8.38,8.37c-.29.19-.58.38-.88.55.1.33.21.66.32,1s.22.63.35.94a.54.54,0,0,0,.05.11c.15.4.31.8.49,1.19s.37.82.57,1.21l.06.13c.17.33.34.66.52,1,.08.15.17.3.26.45s.28.49.43.73l.28.44c.2.32.42.64.64.95a.44.44,0,0,0,.08.11c.21.32.44.63.68.94l.28.35c.21.28.44.55.67.82l.24.28c.23.27.47.53.71.78l.27.28.77.77c.3.29.6.57.91.83s.52.46.79.67a6.4,6.4,0,0,0,.5.41c.37.29.74.57,1.12.84s.7.49,1.07.72a29.76,29.76,0,0,0,16.3,4.79c.33,0,.67,0,1,0l1-.05a28.61,28.61,0,0,0,13.54-4.56,27.08,27.08,0,0,0,12.23-24.77ZM459,283.21a26,26,0,0,1-9.94,11.65,27.59,27.59,0,0,1-12.87,4.26c-.34,0-.67.05-1,.06l-1,0a28.6,28.6,0,0,1-11.42-2.35,28.2,28.2,0,0,1-15-15.06c-.12-.3-.24-.6-.35-.9a31,31,0,0,0,9.46-9.36,34.79,34.79,0,0,0,5.66-19.2,36.4,36.4,0,0,0-.37-5.15c.22-.1.45-.19.67-.27a27.86,27.86,0,0,1,9.85-1.8,28.58,28.58,0,0,1,11.36,2.38,28,28,0,0,1,16.73,21.39c0,.32.1.65.13,1s.08.66.1,1A26,26,0,0,1,459,283.21Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459,283.21a26,26,0,0,1-9.94,11.65c-3.4-3.18-6.88-6.14-10.44-8.92l-.8-.63c-.27-.21-.54-.42-.82-.62A169.9,169.9,0,0,0,417,271.53a34.79,34.79,0,0,0,5.66-19.2,36.4,36.4,0,0,0-.37-5.15c.22-.1.45-.19.67-.27a27.86,27.86,0,0,1,9.85-1.8,28.58,28.58,0,0,1,11.36,2.38,28,28,0,0,1,16.73,21.39c0,.32.1.65.13,1s.08.66.1,1A26,26,0,0,1,459,283.21Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.28,247.59c0-.35-.09-.7-.15-1s-.12-.67-.19-1c-2.8-14.33-14.35-25.07-28.18-25.07A27.06,27.06,0,0,0,375,227.21c-.26.22-.51.45-.76.68s-.51.48-.76.74c.16.32.32.64.46,1a32.12,32.12,0,0,1,.7,24.49,29.94,29.94,0,0,1-7.24,11l-.79.73c.14.33.28.65.43,1s.29.62.45.93c4.91,9.81,14.38,16.45,25.25,16.45a26.58,26.58,0,0,0,12.63-3.2c.3-.16.59-.33.88-.5s.59-.35.88-.54a30.09,30.09,0,0,0,9-8.89,34.49,34.49,0,0,0,5.18-23.46Zm-6.07,23a29.3,29.3,0,0,1-8.38,8.37c-.29.19-.58.38-.88.55s-.58.34-.88.51a25.54,25.54,0,0,1-12.31,3.18c-10.55,0-19.75-6.53-24.47-16.14a32.25,32.25,0,0,0,8.3-12.4,33.88,33.88,0,0,0,2.16-11.95,33.42,33.42,0,0,0-3.27-14.53,26,26,0,0,1,17.28-6.68c13.39,0,24.6,10.52,27.25,24.49.07.34.13.68.17,1h0c.07.34.12.68.16,1a33.89,33.89,0,0,1,.27,4.3A33,33,0,0,1,415.21,270.57Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.61,252.33a33,33,0,0,1-5.4,18.24q-4.43-2.43-8.88-4.55l-.92-.44-.93-.43a206.39,206.39,0,0,0-27.89-10.51,33.88,33.88,0,0,0,2.16-11.95,33.42,33.42,0,0,0-3.27-14.53,26,26,0,0,1,17.28-6.68c13.39,0,24.6,10.52,27.25,24.49.07.34.13.68.17,1h0c.07.34.12.68.16,1A33.89,33.89,0,0,1,420.61,252.33Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.73,228.85c-.15-.32-.31-.64-.47-1s-.31-.6-.47-.9h0c-5-9.17-14.29-15.33-24.89-15.33-15.93,0-28.85,13.9-28.85,31,0,.84,0,1.68.1,2.5,1.18,16,13.6,28.54,28.75,28.54a27.34,27.34,0,0,0,17.38-6.28l.78-.65c.27-.23.53-.47.79-.71a30.94,30.94,0,0,0,7.78-11.73,33.2,33.2,0,0,0-.9-25.51Zm-.07,25.24a29.94,29.94,0,0,1-7.24,11l-.79.73c-.26.23-.52.46-.79.68a26.39,26.39,0,0,1-16.94,6.22c-14.56,0-26.55-12.11-27.74-27.49-.08-.84-.11-1.69-.11-2.55,0-16.56,12.49-30,27.85-30,10.3,0,19.31,6.06,24.12,15.05.17.3.33.61.48.92s.32.64.46,1a32.12,32.12,0,0,1,.7,24.49Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.21,270.57a29.3,29.3,0,0,1-8.38,8.37c-.29.19-.58.38-.88.55s-.58.34-.88.51a25.54,25.54,0,0,1-12.31,3.18c-10.55,0-19.75-6.53-24.47-16.14a32.25,32.25,0,0,0,8.3-12.4,206.39,206.39,0,0,1,27.89,10.51l.93.43.92.44Q410.79,268.15,415.21,270.57Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f8d906"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.09,294.86a27.59,27.59,0,0,1-12.87,4.26c-.34,0-.67.05-1,.06l-1,0a28.6,28.6,0,0,1-11.42-2.35,28.2,28.2,0,0,1-15-15.06c-.12-.3-.24-.6-.35-.9a31,31,0,0,0,9.46-9.36A169.9,169.9,0,0,1,437,284.69c.28.2.55.41.82.62l.8.63C442.21,288.72,445.69,291.68,449.09,294.86Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f8d906"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.26,323.46a28.31,28.31,0,0,1-20.08-1c-.52-.23-1-.47-1.54-.73-.32-.15-.63-.31-.94-.49s-.62-.34-.92-.53a28,28,0,0,1-13.33-19.64A29.66,29.66,0,0,0,450,296.65c.19-.12.38-.24.57-.38q4,3.84,7.85,8.07c.23.24.45.49.67.73s.45.5.67.76A153.87,153.87,0,0,1,473.26,323.46Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f8d906"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488,351.17a29.16,29.16,0,0,1-20.15-.94l-.42-.19-.91-.41c-.3-.15-.59-.3-.88-.47a26.44,26.44,0,0,1-14.19-25.27c.32.16.65.31,1,.45a30.53,30.53,0,0,0,12.12,2.52,29.88,29.88,0,0,0,9.88-1.67q3.12,4.86,6,10.11c.17.29.33.59.49.88l.48.9C483.68,341.55,485.91,346.25,488,351.17Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f8d906"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.52,374.57a24.68,24.68,0,0,1-10.19,2.17c-12.65,0-22.9-9.33-22.9-20.85,0-.33,0-.65,0-1,0-.14,0-.27,0-.4a6.2,6.2,0,0,1,.06-.62,1.36,1.36,0,0,1,0-.2l.06-.48c0-.11,0-.21.05-.32a.88.88,0,0,1,0-.16c0-.07,0-.14,0-.22.06-.32.13-.64.2-.95s.16-.66.25-1l-.9-.46,0,0c-.35-.18-.69-.37-1-.56l0,0-.93-.57-.21-.13-.08-.05c-.29-.2-.59-.39-.87-.59s-.67-.48-1-.74h0l-.17-.14c-.26-.2-.53-.42-.79-.64s-.63-.54-.93-.82l-.35-.33-.29-.27-.05-.05-.08-.08c-.41-.41-.8-.83-1.18-1.26a8.14,8.14,0,0,1-.54-.63c-.38-.45-.74-.91-1.07-1.38-.19-.24-.36-.49-.53-.74s-.25-.36-.36-.55-.22-.34-.33-.52c-.29-.46-.56-.94-.82-1.42a2,2,0,0,1-.13-.25l-.06-.12c-.08-.15-.16-.3-.23-.46-.38-.78-.73-1.58-1-2.4q-.22-.6-.42-1.2a23.35,23.35,0,0,1-.67-2.41c-.09-.4-.18-.81-.25-1.21-.15-.81-.26-1.62-.33-2.44s-.11-1.62-.11-2.43,0-1.52.1-2.28c0-.36.06-.71.11-1.07-.32-.17-.63-.34-.94-.53l-.72-.43-.7-.44,0,0c-.47-.31-.93-.63-1.37-1l-.6-.46-.59-.47-.17-.14-.44-.37-.72-.65,0,0-.68-.66-.47-.48-.61-.66-.48-.55c-.32-.38-.64-.76-.94-1.15a.76.76,0,0,0-.08-.11c-.32-.42-.64-.86-.94-1.3l-.44-.67c-.15-.23-.29-.45-.42-.68-.28-.46-.54-.93-.79-1.4-.12-.23-.25-.47-.36-.71s-.12-.24-.17-.36-.11-.23-.17-.36-.14-.29-.2-.44-.2-.46-.29-.69a23.2,23.2,0,0,1-.86-2.42c-.1-.31-.19-.62-.27-.92-.14-.51-.26-1-.37-1.55s-.2-1-.28-1.56c-.05-.33-.09-.66-.13-1-.32,0-.66,0-1,0a29.76,29.76,0,0,1-16.3-4.79c-.37-.23-.72-.47-1.07-.72s-.75-.55-1.12-.84a6.4,6.4,0,0,1-.5-.41c-.27-.21-.53-.43-.79-.67s-.61-.54-.91-.83l-.77-.77-.27-.28c-.24-.25-.48-.51-.71-.78l-.24-.28c-.23-.27-.46-.54-.67-.82l-.28-.35c-.24-.31-.47-.62-.68-.94a.44.44,0,0,1-.08-.11c-.22-.31-.44-.63-.64-.95l-.28-.44c-.15-.24-.3-.49-.43-.73s-.18-.3-.26-.45c-.18-.32-.35-.65-.52-1l-.06-.13c-.2-.39-.39-.8-.57-1.21s-.34-.79-.49-1.19a.54.54,0,0,1-.05-.11c-.13-.31-.24-.62-.35-.94-.29.17-.58.34-.88.5a26.58,26.58,0,0,1-12.63,3.2c-10.87,0-20.34-6.64-25.25-16.45q-.24-.47-.45-.93l-.78.65a27.34,27.34,0,0,1-17.38,6.28c-15.15,0-27.57-12.56-28.75-28.54l1,.05c1.19,15.38,13.18,27.49,27.74,27.49a26.39,26.39,0,0,0,16.94-6.22c.27-.22.53-.45.79-.68l.79-.73a29.94,29.94,0,0,0,7.24-11l1,.27,1,.28a32.25,32.25,0,0,1-8.3,12.4c4.72,9.61,13.92,16.14,24.47,16.14A25.54,25.54,0,0,0,405.07,280c.3-.17.59-.33.88-.51s.59-.36.88-.55a29.3,29.3,0,0,0,8.38-8.37c.3.15.59.32.89.48l.85.48a31,31,0,0,1-9.46,9.36c.11.3.23.6.35.9a28.2,28.2,0,0,0,15,15.06,28.6,28.6,0,0,0,11.42,2.35l1,0c.34,0,.67,0,1-.06a27.59,27.59,0,0,0,12.87-4.26l.77.71.73.7c-.19.14-.38.26-.57.38a29.66,29.66,0,0,1-13.57,4.46,28,28,0,0,0,13.33,19.64c.3.19.61.36.92.53s.62.34.94.49c.5.26,1,.5,1.54.73a28.31,28.31,0,0,0,20.08,1l.58.87.55.86a29.88,29.88,0,0,1-9.88,1.67,30.53,30.53,0,0,1-12.12-2.52c-.33-.14-.66-.29-1-.45a26.44,26.44,0,0,0,14.19,25.27c.29.17.58.32.88.47l.91.41.42.19a29.16,29.16,0,0,0,20.15.94l.39.93c.13.31.25.62.37.93,1,2.4,1.93,4.85,2.82,7.37a81.43,81.43,0,0,1,6.61,13.22C498.27,373.93,498.39,374.25,498.52,374.57Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f8d906"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.13,339.59c-.24-.22-.5-.44-.76-.65h0c-.26-.2-.52-.4-.8-.6-.18.3-.37.59-.56.88s-.36.54-.55.8a9.1,9.1,0,0,1,.78.61,9.51,9.51,0,0,1,.76.68q5.21,4.95,5.22,14.59c0,7.75-4.91,14.47-12.07,17.73a23.48,23.48,0,0,1-9.83,2.12c-12.07,0-21.89-8.9-21.89-19.85a18.64,18.64,0,0,1,.42-3.9c.08-.33.16-.66.25-1s.19-.64.29-1l-.91-.41c-.3-.15-.59-.3-.88-.47a9.82,9.82,0,0,0-.32,1c-.1.33-.19.66-.27,1a19.78,19.78,0,0,0-.58,4.77c0,12.05,10.72,21.85,23.89,21.85s23.9-9.8,23.9-21.85C512.22,348.73,510.15,343.27,506.13,339.59Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.8,313.94a28.78,28.78,0,0,0-15.27-16.07h0l-1-.43c-.34-.14-.68-.27-1-.39,0,.36,0,.72,0,1.08s0,.72,0,1.08c.34.13.67.27,1,.41l1,.46a26.58,26.58,0,0,1,12.43,35.74,27.66,27.66,0,0,1-1.36,2.52c-.18.3-.37.59-.56.88s-.36.54-.55.8a29.43,29.43,0,0,1-13.73,10.56c-.59.22-1.18.43-1.77.6a29.16,29.16,0,0,1-20.15-.94l-.42-.19-.91-.41c-.3-.15-.59-.3-.88-.47a26.44,26.44,0,0,1-14.19-25.27c0-.35.06-.71.1-1.06s.08-.71.13-1.06c-.32-.15-.63-.31-.94-.49s-.62-.34-.92-.53c-.07.35-.13.71-.17,1.06s-.1.72-.13,1.08a28.27,28.27,0,0,0,1.7,12.85A28.57,28.57,0,0,0,465,351.12c.3.16.61.31.92.45s.61.29.92.42l.18.08a30.82,30.82,0,0,0,12.09,2.46,31.74,31.74,0,0,0,9.6-1.5c.58-.18,1.15-.38,1.72-.59A31.49,31.49,0,0,0,505,341.3c.2-.27.38-.53.56-.81a10.5,10.5,0,0,0,.57-.9,26.71,26.71,0,0,0,1.61-2.92A28.71,28.71,0,0,0,508.8,313.94Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.29,271.31a30.42,30.42,0,0,0-12.42-2.51c-.34,0-.67,0-1,0l-1,.06c0,.32.1.65.13,1s.08.66.1,1c.34,0,.67-.05,1-.06l1,0h.08a28.53,28.53,0,0,1,11.33,2.36,28,28,0,0,1,17,23.9c0,.36,0,.72,0,1.08s0,.72,0,1.08a25.88,25.88,0,0,1-2.12,9.67,26.36,26.36,0,0,1-16.15,14.59,28.31,28.31,0,0,1-20.08-1c-.52-.23-1-.47-1.54-.73-.32-.15-.63-.31-.94-.49s-.62-.34-.92-.53a28,28,0,0,1-13.33-19.64c-.05-.32-.1-.65-.13-1s-.08-.67-.1-1c-.34,0-.67.05-1,.06l-1,0c0,.33.06.67.09,1s.08.66.13,1a30,30,0,0,0,15,21.7c.31.18.63.36,1,.52s.64.33,1,.48.65.31,1,.45a30.53,30.53,0,0,0,12.12,2.52,29.88,29.88,0,0,0,9.88-1.67,29.32,29.32,0,0,0,6-2.88,28.09,28.09,0,0,0,13.11-22.24c0-.37,0-.74,0-1.1s0-.74,0-1.1h0A29.94,29.94,0,0,0,475.29,271.31Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.09,270.78c0-.33-.06-.66-.09-1s-.08-.66-.13-1A30.45,30.45,0,0,0,422.2,245l-.31.13c-.32.11-.64.24-.95.38s-.63.27-.93.42c.07.34.13.68.17,1h0c.07.34.12.68.16,1l.94-.44c.32-.15.64-.29,1-.41s.45-.19.67-.27a27.86,27.86,0,0,1,9.85-1.8,28.58,28.58,0,0,1,11.36,2.38,28,28,0,0,1,16.73,21.39c0,.32.1.65.13,1s.08.66.1,1a26,26,0,0,1-12,24,27.59,27.59,0,0,1-12.87,4.26c-.34,0-.67.05-1,.06l-1,0a28.6,28.6,0,0,1-11.42-2.35,28.2,28.2,0,0,1-15-15.06c-.12-.3-.24-.6-.35-.9s-.24-.63-.34-.95-.22-.66-.32-1c-.29.19-.58.38-.88.55s-.58.34-.88.51c.09.33.2.66.32,1s.22.62.35.93.16.43.25.65a30.16,30.16,0,0,0,16,16.12,30.53,30.53,0,0,0,12.12,2.52h.31c.33,0,.66,0,1,0l1-.06A29.66,29.66,0,0,0,450,296.65c.19-.12.38-.24.57-.38a28,28,0,0,0,12.5-25.49Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.24,247.18c-.05-.35-.1-.68-.17-1h0q-.07-.49-.18-1c-3-14.68-14.91-25.69-29.13-25.69a28,28,0,0,0-18.22,6.84l-.75.66h0c-.26.23-.52.47-.77.72.17.3.33.61.48.92s.32.64.46,1c.25-.26.51-.51.77-.75s.49-.47.75-.69a26,26,0,0,1,17.28-6.68c13.39,0,24.6,10.52,27.25,24.49.07.34.13.68.17,1h0c.07.34.12.68.16,1a33.89,33.89,0,0,1,.27,4.3,33,33,0,0,1-5.4,18.24,29.3,29.3,0,0,1-8.38,8.37c-.29.19-.58.38-.88.55s-.58.34-.88.51a25.54,25.54,0,0,1-12.31,3.18c-10.55,0-19.75-6.53-24.47-16.14-.15-.31-.31-.63-.44-1s-.3-.66-.43-1l-.79.73c-.26.23-.52.46-.79.68.14.32.28.63.44.94a8.68,8.68,0,0,0,.45.92c5.1,10,14.86,16.81,26,16.81a27.41,27.41,0,0,0,13-3.27l.88-.49c.29-.17.58-.34.87-.53a31,31,0,0,0,9.46-9.36,34.79,34.79,0,0,0,5.66-19.2A36.4,36.4,0,0,0,422.24,247.18Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.48,228.16a9.21,9.21,0,0,0-.46-.95c-.15-.3-.31-.6-.48-.89-5.2-9.37-14.75-15.66-25.64-15.66-16.46,0-29.85,14.37-29.85,32s13.39,32,29.85,32a28.34,28.34,0,0,0,17.83-6.36c.26-.2.52-.42.78-.64l.78-.69a32.25,32.25,0,0,0,8.3-12.4,33.88,33.88,0,0,0,2.16-11.95A33.42,33.42,0,0,0,375.48,228.16ZM348.9,272.73c-14.56,0-26.55-12.11-27.74-27.49-.08-.84-.11-1.69-.11-2.55,0-16.56,12.49-30,27.85-30,10.3,0,19.31,6.06,24.12,15.05.17.3.33.61.48.92s.32.64.46,1a32.12,32.12,0,0,1,.7,24.49,29.94,29.94,0,0,1-7.24,11l-.79.73c-.26.23-.52.46-.79.68A26.39,26.39,0,0,1,348.9,272.73Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.75,242.69a31.75,31.75,0,0,1-2.09,11.4q-5-1.44-9.73-2.57l-1-.24-1-.23a240.76,240.76,0,0,0-41.78-5.81c-.08-.84-.11-1.69-.11-2.55,0-16.56,12.49-30,27.85-30,10.3,0,19.31,6.06,24.12,15.05.17.3.33.61.48.92s.32.64.46,1A31.73,31.73,0,0,1,376.75,242.69Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524,427.46c-5.63,16.9-20,20.73-31.42,20.86a59.51,59.51,0,0,1-15.81-2c8.68-1.79,18.13-53.88,18.13-53.88l7.58-5.49,2.63-1.91S533.91,397.59,524,427.46Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.66,254.09a29.94,29.94,0,0,1-7.24,11l-.79.73c-.26.23-.52.46-.79.68a26.39,26.39,0,0,1-16.94,6.22c-14.56,0-26.55-12.11-27.74-27.49a240.76,240.76,0,0,1,41.78,5.81l1,.23,1,.24Q369.69,252.66,374.66,254.09Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f8d906"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.53,448.32a59.51,59.51,0,0,1-15.81-2c8.68-1.79,18.13-53.88,18.13-53.88l7.58-5.49C506.48,403.66,507.06,426.14,492.53,448.32Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f8d906"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.46,384.17l-.52-.23-11,8-.08.39c-3.6,19.89-11.5,51.87-17.34,53.08h-.06c-1.44,0-5.88-.36-9.19-3.1h0l-.17-.15-.24-.21c-1-1-3.63-3.69-3.9-6.8a6,6,0,0,1,1.56-4.55c.45-.31,1.17-.63,1.52-.49s.42.52.51,1.14a1,1,0,0,0,2-.31,3.13,3.13,0,0,0-1.75-2.68c-1.59-.64-3.35.66-3.55.81l-.15.14a8.09,8.09,0,0,0-2.11,6.12c.34,3.84,3.34,7,4.55,8.1.09.09.18.16.25.22l.22.19.11.09.06,0a17.14,17.14,0,0,0,9.26,3.42c.62.05,1.15.23,1.42.23h0a65.05,65.05,0,0,0,14.89,1.67c11.86,0,27.24-3.73,33.16-21.48C535,397.4,505.76,384.3,505.46,384.17Zm17.55,43C514.73,452,487.26,447.79,479.2,446c8-8,15.39-46.51,16.56-52.89l9.41-6.83C509.06,388.1,531.94,400.34,523,427.16Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.51,371.21s8.92-24.48,13.79-29.46c2-2.08,10.55-11.16,20.37,5.26s11.79,41.1.23,43.89-28.6-.66-31.14-3.8S504.51,371.21,504.51,371.21Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f06ba6",
      stroke: "#231f20",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.62,375.13s-52.16-24.63-57.15,4.3,16.26,49.47,38.68,34.34c0,0,22.7-19.84,22.47-24.65S491.62,375.13,491.62,375.13Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f06ba6",
      stroke: "#231f20",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.19,381.58c1.16,6.62,4,14.55,13.08,10.46,5.53-2.5,9.43-2.39,8.7-12.1-.79-10.51-5.67-10.14-11.68-9.69S488.62,372.63,490.19,381.58Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f06ba6",
      stroke: "#231f20",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.23,374.93a1,1,0,0,1-.42-.13,1,1,0,0,1-.38-1.35c.35-.65,8.84-15.67,19.15-12.91,2.67.72,4.39,2.12,5.12,4.16,1.66,4.68-2.79,10.93-3,11.19a1,1,0,0,1-1.39.23,1,1,0,0,1-.23-1.4c0-.05,4-5.66,2.71-9.35-.5-1.41-1.72-2.36-3.75-2.9-8.79-2.37-17.41,13-17.49,13.14C511.37,376,511.6,375,511.23,374.93Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.94,399a5.82,5.82,0,0,1-3.71-.88c-2.23-1.47-3.34-4.57-3.3-9.21a6.85,6.85,0,0,1,2.7-5.58c7-5.49,25.74-1.13,26.53-.94a1,1,0,0,1,.75,1.2c-.13.54.22,1.29-.31,1.16-.19,0-19.48-4.74-25.74.16a4.88,4.88,0,0,0-1.93,4c0,3.85.8,6.45,2.39,7.51,1.79,1.19,4.14.2,4.16.19a1,1,0,0,1,.8,1.83A7.61,7.61,0,0,1,467.94,399Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.54,306.78a16.18,16.18,0,0,0-9.2,3.57c-2.44,2-4.22,4.8-1.61,7.8,4.85,5.55,10.46,7.83,15.52,6a.65.65,0,0,1,.87.75c-.54,2.3-1.26,7,1.61,7.54,3.69.73,15,1.24,21-5.9a.55.55,0,0,1,.94.2c.82,2.83,3.92,10.19,13.66,8.63,8.81-1.4,10.46-7.83,10.72-11.15a.7.7,0,0,1,1.22-.41c2.76,3.13,10.27,9.26,23,2.93a5.74,5.74,0,0,0,1.82-1.38c1.06-1.26,1.84-3.44-2.38-5.71a2.64,2.64,0,0,1-.21-4.52l.08-.05c2.68-1.66,14.94,4.08,18.77-4.09s-19.92-9.7-19.92-9.7Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#ec262b",
      stroke: "#231f20",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.9,244.5c0,40.66-40.36,73.63-90.14,73.63s-90.13-33-90.13-73.63c0-.94,0-1.88.07-2.81a72.1,72.1,0,0,0,37.26-3c23.71-8.34,40.21-27.34,44.74-48.41,7.53,9.67,20.49,18.62,36.48,24.16l2.15.72a97.82,97.82,0,0,1-10.16-11.37,96.08,96.08,0,0,1-9.4-14.93,100.1,100.1,0,0,0,9.51,7.05C297.33,209,319.47,213.48,336,209.33c1,1.53,2,3.09,2.86,4.68a62.68,62.68,0,0,1,3.42,7.11A61.22,61.22,0,0,1,346.9,244.5Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fcc98b",
      stroke: "#231f20",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 137.96,
    cy: 273.44,
    rx: 11.73,
    ry: 9.07,
    style: {
      fill: "#eb468b",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 325.45,
    cy: 275.62,
    rx: 10.33,
    ry: 7.99,
    transform: "translate(-111.97 48.72) rotate(-10.22)",
    style: {
      fill: "#eb468b",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.15,242.7c8.06,2.42,17.76,3.72,29.41,3.32,67.46-2.31,53.62-54.89,53.62-54.89l-50.28,1Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#faae78"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 291.38,
    cy: 248.89,
    rx: 30.17,
    ry: 40.01,
    transform: "translate(-134.2 97.12) rotate(-19.34)",
    style: {
      fill: "#fff",
      stroke: "#231f20",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.73,
    cy: 240.78,
    rx: 29.36,
    ry: 40.85,
    style: {
      fill: "#fff",
      stroke: "#231f20",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.75,259.43s6.64,1,9.32.63",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff",
      stroke: "#231f20",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.34,267.19s4.22,1.41,5.3.64",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff",
      stroke: "#231f20",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.24,273.4s5.28,2.06,6.21.76",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff",
      stroke: "#231f20",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.37,270s-4.34,3.69-6.25,3.76",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff",
      stroke: "#231f20",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.22,276.38s-2.93,3.06-5,2.81",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff",
      stroke: "#231f20",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.33,282.2s-2.93,4.22-4.85,4.09",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff",
      stroke: "#231f20",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.33,232.38a.15.15,0,0,1,.14-.27,23.37,23.37,0,0,1,17.2,18.07c3.71,16.5-2.68,19.34-6,19.34s-12.11-5.13-13.58-18.27c-1.2-10.75,3-12.35,4.59-12.58a.75.75,0,0,0,.63-.75A7,7,0,0,0,284.33,232.38Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.89,238.25a.2.2,0,0,1,.25-.31c3.12,1.46,12.08,6.3,12.95,21.55a31.93,31.93,0,0,1-1.56,12.21,7.79,7.79,0,0,1-12.9,2.83c-2.76-2.77-5.43-7.68-5.26-16.27.3-9.51,4.53-13.73,7.74-14.54a.89.89,0,0,0,.62-1.11A16.11,16.11,0,0,0,245.89,238.25Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.7,196.7a99.32,99.32,0,0,1-9.55-7.09,95.74,95.74,0,0,0,9.44,15A97.89,97.89,0,0,0,287.8,216q-1.08-.34-2.16-.72C269.58,209.75,256.56,200.75,249,191c-4.55,21.17-21.12,40.25-44.94,48.63a72.33,72.33,0,0,1-37.43,3c1.61-35.34,33.57-64.32,75.21-70.1q3.9-.56,7.91-.81l2-.11c1.78-.09,3.57-.13,5.37-.13,1.52,0,3,0,4.51.09,32.44,1.3,60.38,16.55,75.06,38.56C320.08,214.36,297.84,209.87,277.7,196.7Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f3eb29",
      stroke: "#231f20",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.26,295s5.14.32,5.28-1.53c0,0,.44-1-2.08-1.37",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.92,301s4.91,9.63,13,15.51",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,300.6s-3.64-2.17-3.83,2.93",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.65,354s-2.36-4.29-1.34-7.1c0,0-3.66.57-9,7.1,0,0-5.19.48-4.34-8,0,0-8.68.26-5.7,12.43,0,0-8.17.93-10.47,1.1,0,0,3.66,7.66,6.89,8.94,0,0-.08,2.81-2.3,2.55,0,0-2,1.28-.34,2.47,0,0-2.47.34-5.53,3.15,0,0,6.55,1.36,5.36,3.83,0,0-.08,6.21-3.66,6.21,0,0,5.72,6.3,10.82,1.87,0,0,30-14,19.63-34.12",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#35b24a",
      stroke: "#231f20",
      strokeMiterlimit: 10,
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.38,393.12a10,10,0,0,1-1.2-6.87c1.55-9.07,7.26-32.63,24.77-33.25,21.7-.77,33.7,43.15,25,49.53C284.75,408.57,255.5,411.64,244.38,393.12Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#ec262b",
      stroke: "#231f20",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.13,391c2.05,4.57-7.34,7.85-11.26,6.65s-6-8.54-4.54-13.32,6.88-9.43,9.74-6.5C257.94,379.78,258,381.75,262.13,391Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f0582b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.86,
    cy: 353.2,
    r: 2.3,
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.96,
    cy: 375.07,
    r: 2.3,
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.85,340.46c-5,8.19-21.9,36.83-24.59,51.51a4.6,4.6,0,0,0,4,5.41c1.6.14,3.16-.57,3.71-3.53,1.27-6.89,20.42-48,25-50.81,2.3-1.4,1.53-3.3-.27-4.5A5.65,5.65,0,0,0,223.85,340.46Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.71,446.28c2.06,2.32,4.94,2.89,2.73,5.31-1,1.05-5.95.61-8-1.71s-.47-5.73.57-6.7C212.58,440.74,212.66,444,214.71,446.28Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f0582b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.69,452.92c2.06,2.32,4.94,2.89,2.74,5.31-1,1-6,.61-8-1.71s-.48-5.73.56-6.7C273.57,447.38,273.64,450.59,275.69,452.92Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f0582b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,487.64c-1.1,4.19-1.72,8.28,2.28,8.7,2.43.26.86-3.83,3.66-7.13,4.91-5.81,2.47-6.84.33-8C182.52,479.13,181.13,483.46,180,487.64Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#0f7c74"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.68,461.29c-5.25,2.94-10,6.12-7.34,9.19,1.63,1.85,4.69-2.8,10.34-3.83,9.94-1.81,9.12-4.36,8.67-6.83C211.57,455.47,205.93,458.35,200.68,461.29Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#04b9ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.7,478.89c5.32,4.74,10.67,8.92,12.57,5.28,1.16-2.2-4.91-4.19-8.47-9.86-6.26-10-8.47-8.43-10.77-7.3C262,469,267.39,474.15,272.7,478.89Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#04b9ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,498.13c4,1.59,8,2.7,8.91-1.22.55-2.38-3.7-1.32-6.64-4.49-5.17-5.58-6.49-3.29-7.91-1.3C290.83,494.62,295,496.53,299,498.13Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#0f7c74"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.66,33.86s-12,7.31-18.51,27.18a5.27,5.27,0,0,0,7.75,6.17,19,19,0,0,0,1.89-1.36C149.14,59.17,164.05,26.44,149.66,33.86Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.43,78.36s-7.14-4.59-8.85,1.53a12.42,12.42,0,0,0,.22,7.5A4,4,0,0,1,109,92.83h-.15c-5.11-.17-22,15.32-13.28,31.32S108.5,139,108.5,139s4.93-3.58,2-8.51c-2.72-4.65-13.57-15.92-.83-29.56a31.1,31.1,0,0,1,3.84-3.41c1.59-1.23,5.3-4.21,5.15-6.56-.33-5.3-2.56-9,2.15-10.47,1.13-.35,1.7-1.51.64-2.06Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.07,312.69l-3.59.17L411,302.42a2,2,0,0,0-2.13-1.95q-4.43.19-8.89.54l-.47-10.94a2,2,0,0,0-2.12-1.95c-39,1.65-90.72,16.19-119.61,44.95-14.51-11.86-33.94-21.31-56.33-27.37a218.69,218.69,0,0,0-65.63-7.33,2,2,0,0,0-2,2.12l.46,10.93c-3,0-5.94.1-8.91.23a2,2,0,0,0-2,2.13l.44,10.43-3.59.13a2,2,0,0,0-2,2.13l8.23,194a2.05,2.05,0,0,0,2,1.95c43.8.74,80.69,8.23,119,24.23a8.47,8.47,0,0,0,8.51,6.18l23-1a8.49,8.49,0,0,0,8-6.93c36.82-19.16,72.92-29.74,116.46-34.18a2,2,0,0,0,1.83-2.11l-8.23-194A2,2,0,0,0,415.07,312.69Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#0e183d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.64,331.82a307.82,307.82,0,0,0-35.74,14.47,3.87,3.87,0,0,1,0,.48l8.22,193.54c36.1-18.51,71.63-28.91,114.12-33.44l-8.07-190A295.8,295.8,0,0,0,334.64,331.82Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#7bd3f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.64,331.82c4.85-.69,9.73-1.25,14.61-1.67,7.37,7.12,14,15.57,17.24,25.3,3.48,10.43,1.4,22.11-3.64,31.7s-13.35,17.62-23.61,21.4a37.23,37.23,0,0,1-16.8,2.08c-5.48-.57-10.68-2.42-16-3.58a32.49,32.49,0,0,0-4.94-.71l5.69,134c36.1-18.51,71.63-28.91,114.12-33.44l-8.07-190A295.8,295.8,0,0,0,334.64,331.82Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#5dcbf1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.25,330.15l2.26-.19c12.71-1,26.53-1.21,38.44,4,1,.44,2,.93,3,1.46a19,19,0,0,0,.75-3.25,17.85,17.85,0,0,0,1.85,4.83,34.38,34.38,0,0,1,5.47,4.53,16.28,16.28,0,0,0,2.6.49,10.5,10.5,0,0,0-1.53.65c.61.69,1.2,1.41,1.76,2.16,4.31,5.74,6.42,12.57,7.73,19.54,2.9,15.49,1.39,31.67-2.8,46.78a132.73,132.73,0,0,1-20,42c-9.84,13.68-21.8,25.59-34.51,36.6q-5.29,4.59-10.75,9a4.42,4.42,0,0,0,1.6.44c-2.47.8-3,3.94-3.26,4.76a11.68,11.68,0,0,0-1.32-2.8c-2,1.58-4,3.14-5.93,4.7-6.73,5.28-13.43,10.66-20.42,15.58q-3.74,2.63-7.57,5.06l.59,13.84c36.1-18.51,71.63-28.91,114.12-33.44l-8.07-190a295.8,295.8,0,0,0-78.56,15C339.49,331.13,344.37,330.57,349.25,330.15Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#23bfea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.58,328.34l8.06,190c42.75.91,79.06,8.27,116.63,23.68l-8.21-193.58c0-.15,0-.3,0-.44A300.94,300.94,0,0,0,142.58,328.34Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#7bd3f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.07,302.37l.38,9c40,.15,80.69,8.69,116.37,24.49C247.66,314,202.37,300.94,158.07,302.37Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fee6d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.56,292.29c-38.32,2-88.26,16.47-115.7,44.52,33.62-18.88,76-31.76,116.09-35.46Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fee6d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.05,304.64c-41.57,2.11-86.79,14.78-122.55,34.27l5.62-.24a8.47,8.47,0,0,1,7.39,3.76,305.7,305.7,0,0,1,109.9-29.31Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fed6b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.68,339.41c-38.26-16.86-82.35-25.26-125-23.76l.36,8.47a306,306,0,0,1,112.06,19.93,8.44,8.44,0,0,1,7.06-4.4Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fed6b7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.91,446.42c-6,2.1-12.42,1.2-18-1.57-4.79-2.37-8.42-5.91-11.8-10-7.34-8.83-13.12-19.05-21.4-27.05-3.48-3.36-7.43-6.37-12.07-7.18a13.35,13.35,0,0,0-6.3.44,20.94,20.94,0,0,0-7.14,4.15c-4.39,3.71-7.74,8.73-12.81,11.62a17.73,17.73,0,0,1-12.95,1.62l4.24,99.9c42.75.91,79.06,8.27,116.63,23.68l-4.52-106.45C259.18,440.27,254.55,444.45,248.91,446.42Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#5dcbf1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.76,530.13c-9-4.15-16.38-11.09-23.44-17.93-8.66-8.39-17.48-16.57-28.46-21.86-10.2-4.92-21.33-6.63-32.58-6a107.61,107.61,0,0,0-17.78,2.47c-5,1.13-10,2.47-15,3.75l1.18,27.81c42.75.91,79.06,8.27,116.63,23.68Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#23bfea"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.28,
    y: 343.14,
    width: 31.75,
    height: 205.2,
    rx: 4.38,
    transform: "translate(-86.86 -1.01) rotate(-2.43)",
    style: {
      fill: "#3abff0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.29,342.75l-3,.12,8.08,190.32a6.45,6.45,0,0,1-6.15,6.69l-18,.76.17,3.9a4.38,4.38,0,0,0,4.56,4.19l23-1a4.39,4.39,0,0,0,4.2-4.57l-8.33-196.25A4.39,4.39,0,0,0,290.29,342.75Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#18b5e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.33,362.45a14.73,14.73,0,0,0-1-5.68c-1-2.16-3.45-4.06-5.67-2.48-1.93,1.37-2,4.58-2,6.69q1.83,58,3.79,116c.55,16,1.1,32.05,2.67,48a12.68,12.68,0,0,0,1.26,5.14,4.45,4.45,0,0,0,4.36,2.44c3.09-.54,3.69-4.66,3.56-7.8Q281,447,277.62,369.17C277.52,366.93,277.43,364.69,277.33,362.45Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 333.45,
    cy: 420.73,
    rx: 8.55,
    ry: 9.9,
    transform: "translate(-85.76 1.1) rotate(-2.43)",
    style: {
      fill: "#0e183d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 376.4,
    cy: 418.91,
    rx: 8.55,
    ry: 9.9,
    transform: "matrix(1, -0.04, 0.04, 1, -85.64, 2.91)",
    style: {
      fill: "#0e183d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.54,422c.22-.73.71-3.51,2.89-4.22a3.37,3.37,0,0,1-1.8-.64,4.48,4.48,0,0,1-1.4-2.54,4.54,4.54,0,0,1-1.18,2.65,3.4,3.4,0,0,1-1.75.79C330.54,418.52,331.26,421.25,331.54,422Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.24,420.15c.22-.73.71-3.51,2.9-4.22a3.45,3.45,0,0,1-1.81-.64,4.52,4.52,0,0,1-1.4-2.54,4.58,4.58,0,0,1-1.18,2.65,3.4,3.4,0,0,1-1.75.79C373.24,416.71,374,419.44,374.24,420.15Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.59,424.12c.08,1.87,1.27,3.34,2.67,3.28s2.45-1.62,2.37-3.49-1.27-3.35-2.66-3.29S333.51,422.25,333.59,424.12Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 379.16,
    cy: 422.19,
    rx: 2.52,
    ry: 3.39,
    transform: "translate(-85.78 3.04) rotate(-2.43)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.42,442.36c2.92-.13,5.2-2.33,5.09-4.92A5,5,0,0,0,326,433c-2.92.12-5.2,2.32-5.09,4.92S323.5,442.48,326.42,442.36Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f05876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.53,435.36c.11,2.59,2.57,4.59,5.49,4.47s5.2-2.33,5.09-4.92a5,5,0,0,0-5.49-4.47C382.7,430.56,380.42,432.76,380.53,435.36Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f05876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.78,394.7c1.49-5,4.8-24,19.74-28.8-5.1-.62-8.63-1.61-12.32-4.41-3.34-2.52-7.49-8.41-9.56-17.33-1.32,9.07-4.95,15.28-8.07,18.08-3.44,3.1-6.87,4.39-11.9,5.43C170,371.23,174.87,389.84,176.78,394.7Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.36,424.55c.55-1.82,1.76-8.74,7.21-10.51a8.4,8.4,0,0,1-4.5-1.61,11.27,11.27,0,0,1-3.49-6.32,11.3,11.3,0,0,1-2.94,6.6,8.41,8.41,0,0,1-4.35,2C217.87,416,219.66,422.78,220.36,424.55Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.4,441.06c.76-2.53,2.44-12.13,10-14.59a11.63,11.63,0,0,1-6.24-2.23c-1.69-1.27-3.79-4.26-4.84-8.77-.67,4.59-2.51,7.74-4.09,9.15a11.57,11.57,0,0,1-6,2.75C176,429.18,178.43,438.61,179.4,441.06Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.46,360.14a1.6,1.6,0,1,0-1.67-1.53A1.6,1.6,0,0,0,195.46,360.14Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.22,401a2.22,2.22,0,1,0-2.31-2.12A2.22,2.22,0,0,0,158.22,401Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.55,455a1.33,1.33,0,1,0-1.38-1.27A1.33,1.33,0,0,0,200.55,455Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.7,395.8a1.33,1.33,0,0,0,1.27-1.38,1.33,1.33,0,0,0-2.65.11A1.33,1.33,0,0,0,203.7,395.8Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,340.36a10.47,10.47,0,0,1-5.4,2.47c6.93,1.61,9.16,10.05,10,12.25.63-2.09,1.94-9.52,7.42-12.41a10.5,10.5,0,0,1,1.53-.65,16.28,16.28,0,0,1-2.6-.49,8.91,8.91,0,0,1-3-1.5,9.93,9.93,0,0,1-2.49-3,17.85,17.85,0,0,1-1.85-4.83,19,19,0,0,1-.75,3.25A11.56,11.56,0,0,1,390,340.36Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.1,370.23c.24-.82.79-4,3.26-4.76a3.86,3.86,0,0,1-2-.73,5.1,5.1,0,0,1-1.58-2.87,5.14,5.14,0,0,1-1.33,3,3.74,3.74,0,0,1-2,.9C375,366.35,375.78,369.43,376.1,370.23Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.23,376.12c.34-1.15,1.1-5.5,4.53-6.62a5.31,5.31,0,0,1-2.83-1,7.08,7.08,0,0,1-2.19-4,7.13,7.13,0,0,1-1.85,4.16,5.33,5.33,0,0,1-2.74,1.24C393.66,370.73,394.79,375,395.23,376.12Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.87,340.19a.74.74,0,0,0,.7-.76.73.73,0,0,0-1.46.06A.74.74,0,0,0,384.87,340.19Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 342.79,
    r: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.21,383.2a.6.6,0,0,0,.58-.62.62.62,0,0,0-.63-.58.6.6,0,0,0-.57.63A.59.59,0,0,0,386.21,383.2Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.52,356.61a.61.61,0,0,0,.57-.63.59.59,0,0,0-.62-.57.6.6,0,0,0-.58.62A.62.62,0,0,0,382.52,356.61Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,490.4c.68-2.26,2.18-10.86,8.95-13a10.41,10.41,0,0,1-5.58-2c-1.52-1.14-3.4-3.81-4.34-7.85-.59,4.1-2.24,6.92-3.65,8.19a10.46,10.46,0,0,1-5.4,2.46C319,479.76,321.18,488.2,322,490.4Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.44,495.57a5.15,5.15,0,0,1-1.33,3,3.81,3.81,0,0,1-2,.89,4,4,0,0,1,2.34,1.67,11.68,11.68,0,0,1,1.32,2.8c.24-.82.79-4,3.26-4.76a4.42,4.42,0,0,1-1.6-.44,4.73,4.73,0,0,1-.44-.29A5.16,5.16,0,0,1,341.44,495.57Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.74,499.82a7.13,7.13,0,0,1-1.85,4.15,5.29,5.29,0,0,1-2.74,1.24c3.52.82,4.64,5.09,5.08,6.21.34-1.15,1.1-5.5,4.53-6.61a5.24,5.24,0,0,1-2.82-1A7.12,7.12,0,0,1,322.74,499.82Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.45,473.29a.74.74,0,0,0-.7.76.73.73,0,1,0,1.45-.07A.71.71,0,0,0,330.45,473.29Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.59,492.22a1,1,0,0,0-1-1,1,1,0,1,0,1,1Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.76,516.52a.59.59,0,0,0-.57.62.6.6,0,0,0,.62.58.61.61,0,0,0,.58-.63A.6.6,0,0,0,332.76,516.52Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.19,489.7a.61.61,0,0,0-.57.63.6.6,0,0,0,1.2-.05A.6.6,0,0,0,334.19,489.7Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.91,435.2a2.4,2.4,0,0,0-.25-.37,2.67,2.67,0,0,0-1.52-.94,4.41,4.41,0,0,0-2,.12c-1.85.48-3.58,1.49-5.43,2a12.85,12.85,0,0,1-7.34-.57,8.92,8.92,0,0,0-3.79-.87,3.13,3.13,0,0,0-2.14,1.28,3.76,3.76,0,0,0-.54,2.91,10.78,10.78,0,0,0,2.95,5.7l.12.12.31.31h0l.32.28c.3.26.61.5.92.73l.07,0,.55.37.13.08.16.09a11.86,11.86,0,0,0,1.17.61l.41.17.32.13a12.26,12.26,0,0,0,5.48.7l.5-.06a4.89,4.89,0,0,0,.53-.09,8.6,8.6,0,0,0,.88-.19,11.41,11.41,0,0,0,4.27-2.09,12.39,12.39,0,0,0,4-5.82A5.87,5.87,0,0,0,368.91,435.2Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#0e183d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,441.28a11.5,11.5,0,0,0-9,2.21,12.27,12.27,0,0,0,.81.93l.12.12.31.31h0l.32.28c.3.26.61.5.92.73l.07,0,.55.37.13.08.16.09a11.86,11.86,0,0,0,1.17.61l.41.17.32.13a12.26,12.26,0,0,0,5.48.7l.5-.06a4.89,4.89,0,0,0,.53-.09,8.6,8.6,0,0,0,.88-.19,11.45,11.45,0,0,0,2.47-.95C362.4,443.68,360.76,441.74,357,441.28Z",
    transform: "translate(-68.22 -13.42)",
    style: {
      fill: "#f05876"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoriesCategories);
export default __webpack_public_path__ + "static/media/stories-categories.c1508aa433cd9cabe36e4677ebecd0ee.svg";
export { ForwardRef as ReactComponent };